import WalletBalanceCard from '../appComponents/shared/WalletBalanceCard';
import PlatformFooter from '../appComponents/mobile/PlatformFooter';
import PlatformHeader from '../appComponents/mobile/PlatformHeader';
import MobileViewport from '../appComponents/mobile/MobileViewport';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import MobileOverlayStyles from '../appComponents/mobile/MobileOverlayStyles';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import StakeConfirmation from '../appComponents/shared/crypto/StakeConfirmation';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import PasswordPrompt from '../appComponents/shared/crypto/PasswordPrompt';
import React, { Component } from 'react';

import '../appComponents/mobile/css/MobileExperience.css';
import '../appComponents/mobile/css/MobileDeviceWidth.css';
import '../appComponents/mobile/css/MobileResponsiveViewport.css';

import '../appComponents/mobile/css/MobileDeviceWidthGuard.css';
import '../appComponents/mobile/css/MobileHardening.css';
import '../appComponents/mobile/css/MobileConsolidated.css';
import './css/BorrowingAccountMobileRefresh.css';
class BorrowingAccountMobileRender extends Component {
  render() {
    const isBorrowingAccountProfilePage = true; // Hide the credit-line arrow in this page's social overlay.
    const { API, AWS, Amplify, Auth, Bar, BorrowingAccount, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, CartesianGrid, Chart, Component, Container, CryptoJS, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Legend, Line, LineChart, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, Radio, React, ResponsiveContainer, Storage, ThreeDot, Tooltip, Web3, XAxis, YAxis, _approverReceivedRepaymentSum, _approversCt, _approversLoanTotal, _availableCreditReadyWithdraw, _balance, _blenderScore, _blockchainBalance, _borrowerInterestPaid, _borrowingRec, _canDeleteCreditLineBool, _compoundedBalance, _compoundedBalanceWEI, _currentUserContribution, _dateCreated, _exitReclaimableValueWei, _fico, _intRate, _joinDate, _lenders, _lendingRate, _lentTotal, _loanRate, _lookupKey, _managerLCase, _minLoan, _offeredLenderCommissionUSD_adjusted, _openValue, _payableValue, _reclaimableValue, _repayRate, _repaymentTotal, _riskCoverage, _safeReclaimableValueWei, _targetValue, _totalBorrowing, _totalContributed, _totalContributedWei, _totalLending, _totalPaid, _totalWithdrawn, _txnSectionHelpText, _userAvgRating, _userContributed, _userFinalized, _userInterestEarned, _values, _valuesONLY, _web3Balance, _weiCompoundedBalance, _withdrawalRate, accountStatsArray, actionButton, actionText, actionType, actionTypeStakingBool, approverCheck, approverReceivedRepaymentSum, approversCount, approversList, availableCredit, availableCreditRatio, availableCredit_unadjusted, awsconfig, axios, blacklisted, blenderCommissionPublicKey, blenderPercentCharge, blenderPrivateKey, blenderScore, blenderTransfersToPublicKey, borrowerInterestPaid, borrowerStatsArray, borrowingRec, buttonColorFlashIntervalDefault, buttonColorFlashIntervalSecondary, buttonText, campaign, checkValidAuthTokenIntervalPeriod_ms, className, client, closureDateFormatted, cognitoID, compoundInterestReceived, compoundedInterestPaid, contractAddress, contractBalance, contractReceipts, contractStructureType, contributeSignatureNeeded, conversionRateGlobal, corporateBackedUsernamesArray, costText, creditUtilizationPerc, currentUser, currentUserLoanTotal, dataIndexDayMap, deploymentAddress, displayValue, dob, emailAddress, ethers, fico, finalRequestsSum, firstName, forexJSON, formattedValueTooltipString, fullAddress, highRateWeb3, imaginaryInsuranceTotal, insuranceTotal, intRate, interactionHeader, interestRate, ipAddress, isCorporateBondBool, isMobile, lastName, lenderCount, lendingRate, loadingTextInterval, loadingTextIntervalCt, loanRate, loanTarget, manager, managerDisplay, managerUsername, maxDayValue, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, minDayValue, minLoan, minimumContribution, monthLengtheningEnum, navigationHandler, netDebt, noDailyDataPointsFoundBool, offeredLenderCommissionUSD, openContracts, openValue, phoneNumber, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, proposeGasPrice, publicKey, rand1, receiptsCt, reclaimableValue, region, repaidRec, repayRate, repaymentSum, requests, requestsCt, riskCoveragePercentage, routeProps, secondaryDisplayCurrency, secondaryDisplayPrice, secretName, settlementDateFormatted, squareCustomerID, streetAddress, targetValue, that, thisContract_CampaignContract, thisContract_CampaignFactoryContract, thisDeploymentAddress, tokenLifeTimeLimit, tooltipInterval, totalBorrowing, totalContributed, totalCreditMax, totalLending, totalPaid, totalValue, totalWithdrawn, touched, transactionValue, useLayoutEffect, useParams, useRef, userContributed, userFinalized, userFinalizedRequestLoanSum, userInterestEarned, userLiquidValue, userLiquidValuePre, userRiskValue, value, valueDelta, web3, web3BalancePost, web3BalancePre, wishlist, wishlistIcon, withdrawalRate } = this.props;

    // Credit-line card values are read together from the native-equivalent
    // on-chain summary; transaction and chart values are deliberately separate.
    const formatCreditCardUSD = (value) => {
      if (value == null || value === '' || !Number.isFinite(Number(value))) return '—';
      return Math.max(0, Number(value)).toLocaleString(undefined, {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }) + ' USD' + '\n\n';
    };
    const realCreditLimit = that.state.displayCreditLimitUSD;
    const liquidAvailableCredit = that.state.displayAvailableCreditUSD;

    return (
(


          <div className={"pageBody tbp-mobile-redesign tbp-platform tbp-platform--mobile tbp-platform--" + (that.state.mode_light_dark === "light" ? "light" : "dark") + " tbp-platform--" + "borrowing-account"}>
<MobileViewport />
<MobileOverlayStyles />

              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

            <StakeConfirmation
                open={that.state.successOverlay}
                confirmation={that.state.stakeConfirmation}
                onRetry={() => that.retryStakePendingTransaction()}
                theme={that.state.mode_light_dark}
                language={that.state.selectedLanguage}
                onClose={() => {
                    that.setState({ successOverlay: false, stakeConfirmation: null });
                    that.reloadPage();
                }}
            />

<PasswordPrompt
              open={that.state.showPasswordOverlay}
              theme={that.state.mode_light_dark}
              language={that.state.selectedLanguage}
              message={that.state.transactionConfirmationMessage}
              value={that.state.passwordText || ''}
              onChange={(event) => {
                          that.setState({
                            passwordText: event.target.value
                          })
                      }}
              onConfirm={() => {
                        that.setState({
                          showPasswordOverlay: false,
                          pendingTransactionLoaderOverlay: true,
                        })
                        if(that.state.moneyTransactionPreset == 'lend'){
                          that.contributeTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'withdraw'){
                          that.createWithdrawalReqTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'reclaim'){
                          that.rescindTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'stake'){
                          that.stakeTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'claimRewards'){
                          that.claimRewardsTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'repay'){
                          that.repayTxn(that.state.passwordText)
                        }
                      }}
              onCancel={() => {
                that.setState({
                  showPasswordOverlay: false,
                  passwordText: null,
                  passwordIsHiddenBool: true,
                })
              }}
            />
            
            <head>
              <script src="https://www.gstatic.com/charts/loader.js"></script>
            </head>




            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.popupBlockerOverlay}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                    
                    <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                        {that.state.selectedLanguage == 'spanish' ? `Ventanas Emergentes` : `Pop-Up Windows.`}
                    </p>
                </Modal.Header>
                
                <Modal.Content image style={{
    justifyContent: 'space-between',
    marginBottom: 0,
    height: 'auto',
    width: '100%',
    position: 'static',
    margin: 0,
    lineHeight: 1.5,
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                    
                    <Modal.Description style={{
      width: '100%',
      height: 'auto',
      position: 'static',
      margin: 0,
      lineHeight: 1.5
    }}>
                        <Header style={{
        // left: '16vw',
        fontSize: 20,
        // position: 'absolute',
        overflowY: 'hidden',
        overflowX: 'hidden',
        width: '100%',
        marginBottom: 0,
        paddingRight: 16,
        height: 'auto',
        position: 'static',
        margin: 0,
        lineHeight: 1.5
      }}>
                            <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          fontWeight: '600',
          fontSize: 16,
          marginRight: 0,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                              {that.state.selectedLanguage == 'spanish' ? `Habilite ventanas "pop-up" del browser para completar tu transacción.` : `Enable Pop-Up tabs and windows to complete your transaction.`}
                            </p>
                        </Header>
                    
                        <Button content={that.state.selectedLanguage == 'spanish' ? 'Bueno' : 'Okay'}
      // labelPosition='right'
      // icon='checkmark'
      onClick={() => {
        that.setState({
          popupBlockerOverlay: false
        });
      }} positive style={{
        backgroundColor: 'rgba(0, 158, 129, 1)',
        // left: '0vw',
        borderRadius: 3,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        marginLeft: 0,
        marginRight: 0,
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }} />
                    </Modal.Description>
                </Modal.Content>
            </Modal>

        
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.errorTags}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                    
                    <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                        The Blender Platform
                    </p>
                </Modal.Header>
                
                <Modal.Content image style={{
    justifyContent: 'space-between',
    marginBottom: 0,
    height: 'auto',
    width: '100%',
    position: 'static',
    margin: 0,
    lineHeight: 1.5,
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                    
                    <Modal.Description style={{
      width: '100%',
      height: 'auto',
      position: 'static',
      margin: 0,
      lineHeight: 1.5
    }}>
                        <Header style={{
        // left: '16vw',
        fontSize: 17,
        // position: 'absolute',
        overflowY: 'hidden',
        overflowX: 'hidden',
        width: '100%',
        marginBottom: 0,
        paddingRight: 16,
        height: 'auto',
        position: 'static',
        margin: 0,
        lineHeight: 1.5
      }}>
                            <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          fontWeight: '600',
          fontSize: 16,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                            {that.state.selectedLanguage == 'spanish' ? 'Error:' : 'Error:'}
                            </p>
                            <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          fontWeight: '600',
          fontSize: 16,
          marginRight: 0,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                            {that.state.errorTags}
                            </p>
                        </Header>
                    
                        <Button content={that.state.selectedLanguage == 'spanish' ? 'Bueno' : 'Okay'}
      // labelPosition='right'
      // icon='checkmark'
      onClick={() => {
        that.setState({
          successfulDepositOverlay: false,
          errorTags: null
        });
      }} positive style={{
        backgroundColor: 'rgba(0, 158, 129, 1)',
        // left: '0vw',
        borderRadius: 3,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        marginLeft: 0,
        marginRight: 0,
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }} />
                    </Modal.Description>
                </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.pendingTransactionLoaderOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>

              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                    <Header style={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        width: '100%',
        position: 'static',
        margin: 0,
        lineHeight: 1.5
      }}>
                      <p style={{
          fontSize: 19,
          textAlign: 'left',
          marginBottom: 0,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                        {that.state.selectedLanguage == 'spanish' ? "Transacción Pendiente" : "Transaction in Progress"}
                      </p>
                      <div style={{
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 0,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0
        }}>
                        <div className="tbp-overlay-loading" style={{}}><ThreeDot color="rgba(0, 158, 129, 1)" size="large" style={{
              maxWidth: '50px',
              speedPlus: -2
            }} /></div>
                      </div>
                    </Header>
                    
                </Modal.Description>
                
                </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay tbp-overlay-amount " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog' + " tbp-borrow-actions"} open={that.state.moneyTransferOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>
              <div className="tbp-borrow-actions__content" style={{
  fontFamily: 'Lato, Arial, sans-serif',
  marginTop: 0,
  borderRadius: 5,
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: 14,
  fontWeight: '600',
  marginBottom: 0,
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
  padding: 20,
  height: 'auto',
  width: '100%'
}}
// disabled={true}
>

                <WalletBalanceCard balanceWei={that.state.walletBalanceWeiUSD} language={that.state.selectedLanguage} theme={that.state.mode_light_dark} />

                {String(that.state.managerUsername).toLowerCase() != String(that.state.currentUser).toLowerCase() ? <div className="tbp-borrow-tabs-grid" style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 8,
    width: '100%',
    margin: '0 0 20px'
  }}>
                    <Button aria-pressed={that.state.moneyTransactionPreset === "lend"} onClick={() => {
  that.setState({
    moneyTransactionPreset: 'lend'
  });
}} style={{
  backgroundColor: that.state.moneyTransactionPreset == 'lend' ? that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)' : that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)',
  // borderTopLeftRadius: '10px',
  // borderBottomLeftRadius: '10px',
  borderColor: 'rgba(177, 177, 177, 0)',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: 0,
  marginRight: 0,
  paddingLeft: 10,
  paddingRight: 10,
  paddingTop: 0,
  paddingBottom: 0,
  borderRadius: 8,
  height: 'auto',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
  position: 'static',
  minHeight: 54,
  fontSize: 16,
  lineHeight: 1.4,
  boxSizing: 'border-box',
  margin: 0,
  maxWidth: '100%',
  width: '100%',
  padding: '12px 10px'
}} className="tbp-borrow-tab">
                      <p style={{
        textAlign: 'center',
        textAlignVertical: 'center',
        fontSize: 16,
        fontWeight: '600',
        whiteSpace: 'nowrap',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'normal'
      }}>
                        {that.state.selectedLanguage == 'spanish' ? 'Prestar' : 'Lend'}
                      </p>
                    </Button>
                    <Button aria-pressed={that.state.moneyTransactionPreset === "reclaim"} onClick={() => {
  that.setState({
    moneyTransactionPreset: 'reclaim'
  });
}} style={{
  backgroundColor: that.state.moneyTransactionPreset == 'reclaim' ? that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)' : that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)',
  borderColor: 'rgba(177, 177, 177, 0)',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: 0,
  marginRight: 0,
  paddingLeft: 10,
  paddingRight: 10,
  paddingTop: 0,
  paddingBottom: 0,
  borderRadius: 8,
  height: 'auto',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
  position: 'static',
  minHeight: 54,
  fontSize: 16,
  lineHeight: 1.4,
  boxSizing: 'border-box',
  margin: 0,
  maxWidth: '100%',
  width: '100%',
  padding: '12px 10px'
}} className="tbp-borrow-tab">
                      <p style={{
        textAlign: 'center',
        textAlignVertical: 'center',
        fontSize: 16,
        fontWeight: '600',
        whiteSpace: 'nowrap',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'normal'
      }}>
                        {that.state.selectedLanguage == 'spanish' ? 'Reclamar' : 'Reclaim'}
                      </p>
                    </Button>
                    <Button aria-pressed={that.state.moneyTransactionPreset === "stake"} onClick={() => {
  that.setState({
    moneyTransactionPreset: 'stake',
    moneyTransactionLiveValue: '',
    errorTags: null
  });
}} style={{
  backgroundColor: that.state.moneyTransactionPreset == 'stake' ? that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)' : that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)',
  borderColor: 'rgba(177, 177, 177, 0)',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: 0,
  marginRight: 0,
  paddingLeft: 10,
  paddingRight: 10,
  paddingTop: 0,
  paddingBottom: 0,
  borderRadius: 8,
  height: 'auto',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
  position: 'static',
  minHeight: 54,
  fontSize: 16,
  lineHeight: 1.4,
  boxSizing: 'border-box',
  margin: 0,
  maxWidth: '100%',
  width: '100%',
  padding: '12px 10px'
}} className="tbp-borrow-tab">
                      <p style={{
        textAlign: 'center',
        textAlignVertical: 'center',
        fontSize: 16,
        fontWeight: '600',
        whiteSpace: 'nowrap',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'normal'
      }}>
                        {that.state.selectedLanguage == 'spanish' ? 'Aportar' : 'Stake'}
                      </p>
                    </Button>
                    <Button aria-pressed={that.state.moneyTransactionPreset === "claimRewards"} onClick={() => {
  const commissionValue = Number(ethers.utils.formatUnits(String(that.state.availableRewards || '0'), 18)).toFixed(2);
  that.setState({
    moneyTransactionPreset: 'claimRewards',
    moneyTransactionLiveValue: commissionValue,
    errorTags: null
  });
}} style={{
  backgroundColor: that.state.moneyTransactionPreset == 'claimRewards' ? that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)' : that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)',
  borderColor: 'rgba(177, 177, 177, 0)',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: 0,
  marginRight: 0,
  paddingLeft: 4,
  paddingRight: 4,
  borderRadius: 8,
  height: 'auto',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
  position: 'static',
  minHeight: 54,
  fontSize: 15,
  lineHeight: 1.3,
  boxSizing: 'border-box',
  margin: 0,
  maxWidth: '100%',
  width: '100%',
  padding: '12px 8px'
}} className="tbp-borrow-tab">
                      <p style={{
        textAlign: 'center',
        fontSize: 15,
        fontWeight: '600',
        whiteSpace: 'nowrap',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.2,
        overflowWrap: 'normal'
      }}>
                        {that.state.selectedLanguage == 'spanish' ? 'Comisión' : 'Commission'}
                      </p>
                    </Button>
                  </div> : <div className="tbp-borrow-tabs-grid" style={{
    flexDirection: 'row',
    display: 'flex',
    gap: 6,
    width: '100%',
    margin: '0 0 20px'
  }}>
                    <Button aria-pressed={that.state.moneyTransactionPreset === "repay"} onClick={() => {
  that.setState({
    moneyTransactionPreset: 'repay'
  });
}} style={{
  backgroundColor: that.state.moneyTransactionPreset == 'repay' ? that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)' : that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)',
  // borderTopLeftRadius: '10px',
  // borderBottomLeftRadius: '10px',
  borderColor: 'rgba(177, 177, 177, 0)',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: 0,
  marginRight: 0,
  paddingLeft: 10,
  paddingRight: 10,
  paddingTop: 0,
  paddingBottom: 0,
  borderRadius: 0,
  height: 'auto',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
  position: 'static',
  minHeight: 44,
  fontSize: 16,
  lineHeight: 1.4,
  boxSizing: 'border-box',
  margin: 0,
  maxWidth: '100%',
  flex: 1,
  width: 'auto',
  padding: '12px 6px'
}} className="tbp-borrow-tab">
                      <p style={{
        textAlign: 'center',
        textAlignVertical: 'center',
        fontSize: 16,
        fontWeight: '600',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'anywhere'
      }}>
                        {that.state.selectedLanguage == 'spanish' ? 'Pagar' : 'Repay'}
                      </p>
                    </Button>
                    <Button aria-pressed={that.state.moneyTransactionPreset === "withdraw"} onClick={() => {
  that.setState({
    moneyTransactionPreset: 'withdraw'
  });
}} style={{
  backgroundColor: that.state.moneyTransactionPreset == 'withdraw' ? that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)' : that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)',
  borderColor: 'rgba(177, 177, 177, 0)',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: 0,
  marginRight: 0,
  paddingLeft: 10,
  paddingRight: 10,
  paddingTop: 0,
  paddingBottom: 0,
  borderRadius: 0,
  height: 'auto',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
  position: 'static',
  minHeight: 44,
  fontSize: 16,
  lineHeight: 1.4,
  boxSizing: 'border-box',
  margin: 0,
  maxWidth: '100%',
  flex: 1,
  width: 'auto',
  padding: '12px 6px'
}} className="tbp-borrow-tab">
                      <p style={{
        textAlign: 'center',
        textAlignVertical: 'center',
        fontSize: 16,
        fontWeight: '600',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'anywhere'
      }}>

                        {that.state.selectedLanguage == 'spanish' ? 'Retirar' : 'Withdraw'}
                      </p>
                    </Button>
                  </div>}
                
              
                <div className="tbp-amount-entry"><input value={that.state.moneyTransactionLiveValue == null ? '' : that.state.moneyTransactionLiveValue} readOnly={that.state.moneyTransactionPreset == 'claimRewards'} min="0" step="any" aria-label={that.state.selectedLanguage == 'spanish' ? 'Importe en USD' : 'Stake Amount in USD'} autocomplete="off" maxlength="5" type="number" id="text" outline="none" onChange={event => {
      that.setState({
        moneyTransactionLiveValue: event.target.value
      });
    }} name="text" placeholder={that.state.moneyTransactionPreset == 'repay' ? `MIN ${Math.min(Number(minimumContribution || 0) / 1000000000000000000, Number(_compoundedBalance || 0)).toFixed(2)}` : '0'} style={{
      fontWeight: '600',
      fontFamily: 'arial',
      paddingTop: '3vh',
      textAlign: 'left',
      textAlignVertical: 'center',
      borderWidth: 0,
      borderStyle: 'none',
      borderBottomColor: 'rgba(177, 177, 177, 0)',
      height: 'auto',
      marginRight: 0,
      paddingLeft: 16,
      paddingRight: 16,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      maxWidth: '100%',
      backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
      border: '1px solid rgba(128,128,128,.4)',
      borderRadius: 4,
      boxSizing: 'border-box',
      fontSize: 32,
      minHeight: 72,
      padding: 16,
      width: '100%',
      margin: 0
    }} /><span>USD</span></div>
                

                
                      
                

                <div style={{
    marginTop: 0,
    // backgroundColor: that.state.searchedUser_foundUsername ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0.1)',
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: '600',
    flex: 'display',
    flexDirection: 'column',
    height: 'auto',
    width: '100%',
    marginBottom: 0
  }}
  // disabled={true}
  >
                  <Button disabled={that.state.disableWhileTxn || !Number.isFinite(Number(that.state.moneyTransactionLiveValue)) || Number(that.state.moneyTransactionLiveValue) <= 0} onClick={() => {
  if (Number(that.state.moneyTransactionLiveValue) > 0) {
    {
      if (that.state.moneyTransactionPreset == 'lend') {
        that.setState({
          showPasswordOverlay: true,
          passwordIsHiddenBool: true,
          transactionConfirmationMessage: `Lend ${Number(that.state.moneyTransactionLiveValue).toFixed(2)} USD to ${String(that.state.managerDisplayName).toUpperCase()} 's Credit Line.`
        });
      } else if (that.state.moneyTransactionPreset == 'reclaim') {
        that.setState({
          showPasswordOverlay: true,
          passwordIsHiddenBool: true,
          transactionConfirmationMessage: `Reclaim ${Number(that.state.moneyTransactionLiveValue).toFixed(2)} USD from ${String(that.state.managerDisplayName).toUpperCase()} 's Credit Line.`
        });
      } else if (that.state.moneyTransactionPreset == 'stake') {
        that.setState({
          showPasswordOverlay: true,
          passwordIsHiddenBool: true,
          transactionConfirmationMessage: `Stake Amount: ${that.state.moneyTransactionLiveValue} USD. Credit Line: ${String(that.state.managerDisplayName).toUpperCase()}. Funds Will Be Added As Collateral.`
        });
      } else if (that.state.moneyTransactionPreset == 'claimRewards') {
        that.setState({
          showPasswordOverlay: true,
          passwordIsHiddenBool: true,
          transactionConfirmationMessage: `Withdraw ${Number(that.state.moneyTransactionLiveValue).toFixed(2)} USD in Staking Commissions.`
        });
      } else if (that.state.moneyTransactionPreset == 'repay') {
        const minimumRepayValue = Number(minimumContribution || 0) / 1000000000000000000;
        const remainingDebtValue = Number(_compoundedBalance || 0);
        const enteredRepayValueRaw = Number(that.state.moneyTransactionLiveValue || 0);
        const enteredRepayValue = Number.isFinite(enteredRepayValueRaw) ? enteredRepayValueRaw : 0;
        const effectiveMinimumRepay = Math.min(minimumRepayValue, remainingDebtValue);
        const normalizedRepayValue = Math.min(
          Math.max(enteredRepayValue, effectiveMinimumRepay),
          remainingDebtValue
        );
        that.setState({
          moneyTransactionLiveValue: normalizedRepayValue.toFixed(2),
          showPasswordOverlay: true,
          passwordIsHiddenBool: true,
          transactionConfirmationMessage: `Repay ${normalizedRepayValue.toFixed(2)} USD to the Lenders of your Credit Line.`
        });
      } else if (that.state.moneyTransactionPreset == 'withdraw') {
        that.setState({
          showPasswordOverlay: true,
          passwordIsHiddenBool: true,
          transactionConfirmationMessage: `Withdraw ${Number(that.state.moneyTransactionLiveValue).toFixed(2)} USD from the Lenders of your Credit Line.`
        });
      }
    }
  }
}} style={{
  backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.0)' : 'rgba(255, 255, 255, 0.0)',
  // borderTopLeftRadius: '10px',
  // borderBottomLeftRadius: '10px',
  borderColor: 'rgba(177, 177, 177, 0)',
  justifyContent: 'center',
  alignItems: 'center',
  borderBottomStyle: 'solid',
  borderWidth: 0.1,
  borderColor: 'rgba(41, 41, 41, 0.1)',
  borderRadius: 0,
  height: 'auto',
  width: '100%',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
  position: 'static',
  minHeight: 44,
  fontSize: 16,
  lineHeight: 1.4,
  boxSizing: 'border-box',
  margin: 0,
  padding: '12px 16px',
  maxWidth: '100%'
}} className="tbp-borrow-submit">
                    <p style={{
        textAlign: 'center',
        textAlignVertical: 'center',
        fontSize: 18,
        fontWeight: '600',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'anywhere'
      }}>

                      {that.state.selectedLanguage == 'spanish' ? that.state.moneyTransactionPreset == 'lend' ? 'Prestar' : that.state.moneyTransactionPreset == 'reclaim' ? 'Reclamar' : that.state.moneyTransactionPreset == 'stake' ? 'Aportar' : that.state.moneyTransactionPreset == 'claimRewards' ? 'Retirar Comisión' : that.state.moneyTransactionPreset == 'repay' ? 'Pagar' : that.state.moneyTransactionPreset == 'withdraw' ? 'Retirar' : null : that.state.moneyTransactionPreset == 'lend' ? 'Lend' : that.state.moneyTransactionPreset == 'reclaim' ? 'Reclaim' : that.state.moneyTransactionPreset == 'stake' ? 'Stake' : that.state.moneyTransactionPreset == 'claimRewards' ? 'Withdraw Commission' : that.state.moneyTransactionPreset == 'repay' ? 'Repay' : that.state.moneyTransactionPreset == 'withdraw' ? 'Withdraw' : null}
                    </p>
                  </Button>
                  <Button onClick={() => {
  that.setState({
    moneyTransferOverlay: false
  });
}} style={{
  backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.0)' : 'rgba(255, 255, 255, 0.0)',
  justifyContent: 'center',
  alignItems: 'center',
  borderBottomStyle: 'none',
  borderWidth: 0.1,
  borderColor: 'rgba(41, 41, 41, 0.1)',
  borderRadius: 0,
  height: 'auto',
  width: '100%',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
  position: 'static',
  minHeight: 44,
  fontSize: 16,
  lineHeight: 1.4,
  boxSizing: 'border-box',
  margin: 0,
  padding: '12px 16px',
  maxWidth: '100%'
}} className="tbp-borrow-cancel">
                    <p style={{
        textAlign: 'center',
        textAlignVertical: 'center',
        fontSize: 16,
        fontWeight: '600',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'anywhere'
      }}>
                      {'Close'}
                    </p>
                  </Button>
                </div>

              </div>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={'tbp-mobile-profile ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark') + ' tbp-mobile-dialog'} open={that.state.socialOverlay}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                            
              <div style={{
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
    padding: 16,
    width: '100%',
    height: 'auto'
  }} className={'tbp-profile-body'}><div style={{
      marginBottom: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      width: '100%',
      margin: '0 0 16px'
    }}><button onClick={() => {
        that.setState({
          socialOverlay: false
        });
      }} style={{
        borderStyle: 'solid',
        borderColor: 'rgba(0, 0, 0, 0)',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        gap: 8,
        border: 0,
        flexShrink: 0,
        width: 44,
        height: 44,
        flex: '0 0 44px',
        margin: 0,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        borderRadius: 4
      }} className={'tbp-profile-control'}>
                  <i className="close icon" style={{
          marginLeft: 2.5,
          fontWeight: '600',
          color: 'rgba(255, 255, 255, 1)',
          zIndex: 1,
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          fontSize: 20,
          margin: 0,
          width: 20,
          height: 20,
          lineHeight: 1,
          flexShrink: 0
        }} />
                </button>{!isBorrowingAccountProfilePage && <Link to={`/borrowingacct/${that.state.socialOverlayData_contractAddress}`} style={{
        borderStyle: 'solid',
        borderColor: 'rgba(0, 0, 0, 0)',
        zIndex: 1,
        flexShrink: 0,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: 44,
        height: 44,
        flex: '0 0 44px',
        margin: 0,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        borderRadius: 4
      }} className={'tbp-profile-control'}>
                  <i className="arrow right icon" style={{
          marginLeft: 2.5,
          fontWeight: '600',
          color: 'rgba(255, 255, 255, 1)',
          zIndex: 1,
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          fontSize: 20,
          margin: 0,
          width: 20,
          height: 20,
          lineHeight: 1,
          flexShrink: 0
        }} />
                </Link>}</div><div className="tbp-profile-summary"><img src={that.state.socialOverlayData_imageURI} alt="" /><div><strong>{String(that.state.socialOverlayData_username || '').toUpperCase()}</strong><div>{that.state.socialOverlayData_fullName}</div></div><p>{that.state.socialOverlayData_bioString}</p></div><div className="tbp-social-feed">{that.state.mediaMapArray ? that.state.mediaMapArray.map(listItemA => <div class="scrollContainer" style={{
        justifyContent: 'start',
        zIndex: 1,
        boxSizing: 'border-box',
        flexDirection: 'column',
        alignItems: 'stretch',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        height: 'auto',
        minHeight: 0,
        minWidth: 0,
        maxWidth: '100%',
        position: 'static',
        gap: 8,
        overflow: 'visible',
        overflowX: 'visible',
        overflowY: 'visible',
        display: 'block',
        width: '100%',
        margin: '0 0 24px',
        padding: '0 0 20px',
        borderBottom: '1px solid rgba(128,128,128,.25)'
      }} accessible={false} className={'tbp-social-post'}>









                                    <div style={{
          zIndex: 1,
          boxSizing: 'border-box',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          marginRight: 0,
          height: 'auto',
          minHeight: 0,
          width: '100%',
          minWidth: 0,
          maxWidth: '100%',
          position: 'static',
          margin: 0,
          padding: 0,
          gap: 8,
          display: 'block',
          overflow: 'visible',
          overflowX: 'visible',
          overflowY: 'visible'
        }}>
                                      {String(listItemA.mediaURI).includes("mp4") ? <video controls autoplay={true} ref={ref => {
            that.player = ref;
          }} style={{
            // marginRight: 50,
            marginLeft: 0,
            borderColor: 'rgba(0, 0, 0, 0.5)',
            borderStyle: 'solid',
            borderRadius: 4,
            borderWidth: 1,
            objectFit: 'cover',
            zIndex: 1,
            boxSizing: 'border-box',
            position: 'static',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            width: '100%',
            height: 'auto',
            maxHeight: 480,
            display: 'block'
          }} fullscreen={listItemA.mediaURI == that.state.fullScreenViewerURI}>
                                          <source src={listItemA.mediaURI} type="video/mp4" style={{}} />  
                                        </video> : <img style={{
            // marginRight: 50,
            marginLeft: 0,
            borderColor: 'rgba(0, 0, 0, 0.5)',
            borderStyle: 'solid',
            borderWidth: 1,
            zIndex: 1,
            flexShrink: 0,
            position: 'static',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            width: '100%',
            height: 'auto',
            minWidth: 0,
            maxWidth: '100%',
            maxHeight: 480,
            objectFit: 'contain',
            borderRadius: 0,
            border: 'none',
            margin: 0,
            display: 'block'
          }} src={listItemA.mediaURI} />}

                                    </div>    










                                    <div class="scrollNoScrollBar" style={{
          flexDirection: 'column',
          MsOverflowStyle: 'none',
          /* IE and Edge */
          scrollbarWidth: 'none' /* Firefox */,

          zIndex: 1,
          boxSizing: 'border-box',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          marginBottom: 0,
          height: 'auto',
          minHeight: 0,
          width: '100%',
          minWidth: 0,
          maxWidth: '100%',
          position: 'static',
          margin: 0,
          padding: 0,
          gap: 8,
          display: 'block',
          overflow: 'visible',
          overflowX: 'visible',
          overflowY: 'visible'
        }}>

                                      <div style={{
            // position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            marginTop: 0,
            flexDirection: 'column',
            justifyContent: 'left',
            alignItems: 'center',
            paddingBottom: 10,
            boxSizing: 'border-box',
            marginBottom: 0,
            height: 'auto',
            minHeight: 0,
            width: '100%',
            minWidth: 0,
            maxWidth: '100%',
            position: 'static',
            margin: 0,
            padding: 0,
            gap: 8,
            display: 'block',
            overflow: 'visible',
            overflowX: 'visible',
            overflowY: 'visible'
          }}>
                                        <div style={{
              left: 0,
              right: 0,
              top: 0,
              marginTop: 0,
              justifyContent: 'left',
              boxSizing: 'border-box',
              flexDirection: 'column',
              alignItems: 'stretch',
              height: 'auto',
              minHeight: 0,
              width: '100%',
              minWidth: 0,
              maxWidth: '100%',
              position: 'static',
              margin: 0,
              padding: 0,
              gap: 8,
              display: 'block',
              overflow: 'visible',
              overflowX: 'visible',
              overflowY: 'visible'
            }}>         
                                          <div style={{
                // position: 'absolute',
                // height: 200,
                left: 0,
                right: 0,
                top: 0,
                marginTop: 0,
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxSizing: 'border-box',
                height: 'auto',
                minHeight: 0,
                width: '100%',
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                margin: 0,
                padding: 0,
                gap: 8,
                display: 'block',
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible'
              }}>
                                            <p style={{
                  // right: 0,
                  paddingBottom: 50,
                  textAlign: 'left',
                  textAlignVertical: 'top',
                  // borderStyle: 'solid',
                  borderColor: 'rgba(0, 0, 0, 1)',
                  borderWidth: 0.5,
                  // top: 0, 
                  fontWeight: '600',
                  // paddingRight: 10,
                  marginTop: 0,
                  // bottom: 500,
                  paddingLeft: 0,
                  marginLeft: 0,
                  wordBreak: 'breakAll',
                  whiteSpace: 'normal',
                  zIndex: 1,
                  boxSizing: 'border-box',
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  margin: '4px 0',
                  padding: 0,
                  width: 'auto',
                  height: 'auto',
                  fontSize: 14,
                  lineHeight: 1.5,
                  overflowWrap: 'break-word'
                }}>
                                              {`${String(listItemA.publisherUsername).toUpperCase()}`}
                                            </p>
                                            <p style={{
                  fontWeight: '400',
                  marginBottom: 7,
                  justifyContent: 'start',
                  alignItems: 'center',
                  textAlign: 'left',
                  textAlignVertical: 'top',
                  borderColor: 'rgba(0, 0, 0, 1)',
                  borderWidth: 0.5,
                  paddingRight: 10,
                  paddingLeft: 0,
                  marginLeft: 0,
                  wordBreak: 'breakAll',
                  whiteSpace: 'normal'
                  // backgroundColor: 'purple',
                  ,

                  zIndex: 1,
                  boxSizing: 'border-box',
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  marginTop: 0,
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  margin: '4px 0',
                  padding: 0,
                  width: 'auto',
                  height: 'auto',
                  fontSize: 14,
                  lineHeight: 1.5,
                  overflowWrap: 'break-word'
                }}>
                                                {`${listItemA.mediaItemCaption}`}
                                                {/* qelfb wejv wejk vejwejv wejvw kwejqbgwe wefnb wej je ewjf e wej f ejwf jejee qwefjbu 2qui 2  2q b22fbu2 q2fbuq qwufib qwfuuwb iwhb  qubf quwfb quf uqwbf */}

                                              </p>
                                          </div>
                                        





                                          <div style={{
                justifyContent: 'end',
                zIndex: 1,
                boxSizing: 'border-box',
                flexDirection: 'column',
                top: 'auto',
                left: 'auto',
                right: 'auto',
                bottom: 'auto',
                height: 'auto',
                minHeight: 0,
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                padding: 0,
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 8,
                width: '100%',
                margin: '8px 0'
              }} className={'tbp-social-actions'}>
                                            <Button onClick={() => {
                  that.setState({
                    commentReplyID: null,
                    newCommentStringInput: null,
                    commentInitMediaFileName: listItemA.mediaFileName,
                    commentViewerMediaFileName: null
                  });
                }} style={{
                  zIndex: 1,
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  marginBottom: 0,
                  fontSize: 16,
                  lineHeight: 1.4,
                  boxSizing: 'border-box',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  borderRadius: 4,
                  flexShrink: 0,
                  width: 'auto',
                  minWidth: 44,
                  maxWidth: '100%',
                  height: 44,
                  minHeight: 44,
                  padding: '8px 10px',
                  margin: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  backgroundColor: 'transparent',
                  border: 0,
                  boxShadow: 'none'
                }} className={'tbp-social-action ui button'}>
                                              <i className="pen square icon" size={35} style={{
                    color: 'rgba(0, 0, 0, 1)',
                    zIndex: 1,
                    position: 'static',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    fontSize: 20,
                    margin: 0,
                    width: 20,
                    height: 20,
                    lineHeight: 1,
                    flexShrink: 0
                  }} />
                                            </Button>
                                            <Button onClick={() => {
                  let likesArray = [];
                  authenticatedPut('api1169ba1e', '', {
                    headers: {
                      Authorization: `Bearer ${cognitoID}`
                    },
                    body: {
                      category: 'db',
                      tableName: 'mediaUploads',
                      primaryKey: String(listItemA.mediaFileName),
                      requestOperation: 'get'
                    }
                  }).then(mediaData => {
                    if (mediaData.hasOwnProperty('Item')) {
                      if (mediaData.Item.hasOwnProperty('likesArray')) {
                        likesArray = mediaData.Item.likesArray;
                      }
                      if (likesArray.includes(currentUser.toLowerCase())) {
                        let indexToRemove = likesArray.indexOf(currentUser.toLowerCase());
                        likesArray.splice(indexToRemove, 1);
                        authenticatedPut('api1169ba1e', '', {
                          headers: {
                            Authorization: `Bearer ${cognitoID}`
                          },
                          body: {
                            category: 'db',
                            tableName: 'mediaUploads',
                            primaryKey: String(listItemA.mediaFileName),
                            requestOperation: 'update',
                            updateExpression: `SET 
                                                                  likesArray = :likesArray
                                                                `,
                            expressionAttributeValues: {
                              ':likesArray': likesArray
                            }
                          }
                        }).then(res => {
                          let likedMediaItemMap = that.state.likedMediaItemMap;
                          likedMediaItemMap[String(listItemA.mediaFileName)] = false;
                          that.setState({
                            likedMediaItemMap,
                            socialOverlay: false
                          }, () => {
                            that.setState({
                              socialOverlay: true
                            });
                          });
                        });
                      } else {
                        authenticatedPut('api1169ba1e', '', {
                          headers: {
                            Authorization: `Bearer ${cognitoID}`
                          },
                          body: {
                            category: 'db',
                            tableName: 'mediaUploads',
                            primaryKey: String(listItemA.mediaFileName),
                            requestOperation: 'update',
                            updateExpression: `SET 
                                                                  likesArray = list_append(likesArray, :likesArray)
                                                                `,
                            expressionAttributeValues: {
                              ':likesArray': [currentUser.toLowerCase()]
                            }
                          }
                        }).then(res => {
                          let likedMediaItemMap = that.state.likedMediaItemMap;
                          likedMediaItemMap[String(listItemA.mediaFileName)] = true;
                          that.setState({
                            likedMediaItemMap,
                            socialOverlay: false
                          }, () => {
                            that.setState({
                              socialOverlay: true
                            });
                          });
                        });
                      }
                    }
                  });
                }} style={{
                  zIndex: 1,
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  marginBottom: 0,
                  marginRight: 0,
                  fontSize: 16,
                  lineHeight: 1.4,
                  boxSizing: 'border-box',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  borderRadius: 4,
                  flexShrink: 0,
                  width: 'auto',
                  minWidth: 44,
                  maxWidth: '100%',
                  height: 44,
                  minHeight: 44,
                  padding: '8px 10px',
                  margin: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  backgroundColor: 'transparent',
                  border: 0,
                  boxShadow: 'none'
                }} className={'tbp-social-action ui button'}>
                                              <i className={listItemA.likesArray.includes(currentUser) ? "heart icon" : "heart outline icon"} size={35} style={{
                    color: 'rgba(204, 12, 12, 1)',
                    zIndex: 1,
                    position: 'static',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    fontSize: 20,
                    margin: 0,
                    width: 20,
                    height: 20,
                    lineHeight: 1,
                    flexShrink: 0
                  }} />
                                              <div style={{
                    justifyContent: 'center',
                    alignItems: 'center'
                    // // borderWidth: 1,
                    ,

                    zIndex: 1,
                    boxSizing: 'border-box',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    height: 'auto',
                    minHeight: 0,
                    width: '100%',
                    minWidth: 0,
                    maxWidth: '100%',
                    position: 'static',
                    margin: 0,
                    padding: 0,
                    gap: 8,
                    display: 'block',
                    overflow: 'visible',
                    overflowX: 'visible',
                    overflowY: 'visible'
                  }}>
                                                <p style={{
                      textAlign: 'left',
                      fontWeight: '600',
                      boxSizing: 'border-box',
                      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                      margin: '4px 0',
                      padding: 0,
                      width: 'auto',
                      height: 'auto',
                      fontSize: 14,
                      lineHeight: 1.5,
                      overflowWrap: 'break-word'
                    }}> 
                                                  {listItemA.likesArray ? listItemA.likesArray.length : null}
                                                {/* 900 */}
                                                </p>
                                              </div>
                                            </Button>
                                          </div>

                                        </div>   
                                      </div>

                                      {that.state.commentInitMediaFileName == listItemA.mediaFileName
          // true
          ? <div style={{
            marginTop: 0,
            zIndex: 1,
            boxSizing: 'border-box',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            marginBottom: 0,
            height: 'auto',
            minHeight: 0,
            width: '100%',
            minWidth: 0,
            maxWidth: '100%',
            position: 'static',
            margin: 0,
            padding: 0,
            gap: 8,
            display: 'block',
            overflow: 'visible',
            overflowX: 'visible',
            overflowY: 'visible'
          }}> 
                                          <input autocomplete="off" type="text" id="textComment"
            // className="loginInput"  
            value={that.state.newCommentStringInput} onChange={event => {
              that.setState({
                newCommentStringInput: event.target.value
              });
            }} name="text" maxLength="100" placeholder={that.state.selectedLanguage == 'spanish' ? 'Drop a Comment' : 'Comentar'} placeholderTextColor={'rgba(0, 0, 0, 1)'} wrap="hard" wordWrap='breakWord' wordBreak='breakAll' style={{
              justifyContent: 'center',
              alignContent: 'center',
              alignSelf: 'center',
              textAlign: 'left',
              textAlignVertical: 'center',
              opacity: 0.95,
              fontWeight: '600',
              marginBottom: 10,
              paddingLeft: 10,
              paddingRight: 4,
              height: 'auto',
              color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
              maxWidth: '100%',
              backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
              border: '1px solid rgba(128,128,128,.4)',
              borderRadius: 4,
              boxSizing: 'border-box',
              width: '100%',
              fontSize: 16,
              padding: 12,
              minHeight: 44,
              margin: '8px 0'
            }} />
                                          
                                          <div style={{
              marginBottom: 10,
              paddingBottom: 5,
              justifyContent: 'end',
              boxSizing: 'border-box',
              flexDirection: 'column',
              height: 'auto',
              minHeight: 0,
              minWidth: 0,
              maxWidth: '100%',
              position: 'static',
              padding: 0,
              overflow: 'visible',
              overflowX: 'visible',
              overflowY: 'visible',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 8,
              width: '100%',
              margin: '8px 0'
            }} className={'tbp-social-actions'}>
                                            <Button onClick={() => {
                that.setState({
                  newCommentStringInput: null,
                  commentReplyID: null,
                  commentInitMediaFileName: null,
                  commentIsWritingMediaFileName: null
                });
              }} style={{
                borderColor: 'rgba(256, 256, 256, 1)',
                zIndex: 9999,
                position: 'static',
                fontSize: 16,
                lineHeight: 1.4,
                boxSizing: 'border-box',
                color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                borderRadius: 4,
                flexShrink: 0,
                width: 'auto',
                minWidth: 44,
                maxWidth: '100%',
                height: 44,
                minHeight: 44,
                padding: '8px 10px',
                margin: 0,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 6,
                backgroundColor: 'transparent',
                border: 0,
                boxShadow: 'none'
              }} className={'tbp-social-action ui button'}>                  
                                              <p style={{
                  textAlign: 'center',
                  textAlignVertical: 'top',
                  fontWeight: '600',
                  marginBottom: 5,
                  zIndex: 1,
                  boxSizing: 'border-box',
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  margin: '4px 0',
                  padding: 0,
                  width: 'auto',
                  height: 'auto',
                  fontSize: 14,
                  lineHeight: 1.5,
                  overflowWrap: 'break-word'
                }}> 
                                              {that.state.selectedLanguage == 'spanish' ? 'Borrar' : 'Discard'}
                                              </p>
                                            </Button>
                                            <Button onClick={() => {
                var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                randomString1 = String(currentUser).concat(randomString1.substring(0, 18));
                if (that.state.newCommentStringInput != null) {
                  if (String(that.state.newCommentStringInput).length > 1) {
                    authenticatedPut('api1169ba1e', '', {
                      headers: {
                        Authorization: `Bearer ${cognitoID}`
                      },
                      body: {
                        category: 'db',
                        tableName: 'mediaUploads',
                        primaryKey: String(listItemA.mediaFileName),
                        requestOperation: 'update',
                        updateExpression: `SET 
                                                                commentsMapArray = list_append(commentsMapArray, :newCommentMap)
                                                              `,
                        expressionAttributeValues: {
                          ':newCommentMap': [{
                            sender: currentUser.toLowerCase(),
                            sentTimestamp: Date.now(),
                            messageText: String(that.state.newCommentStringInput),
                            messageID: randomString1,
                            subReplyCommentsArray: [],
                            likesArray: []
                          }]
                        }
                      }
                    }).then(res => {
                      authenticatedPut('api1169ba1e', '', {
                        headers: {
                          Authorization: `Bearer ${cognitoID}`
                        },
                        body: {
                          category: 'db',
                          tableName: 'mediaUploadComments',
                          primaryKey: randomString1,
                          requestOperation: 'update',
                          updateExpression: `SET 
                                                                  commentsReplyMapArray = :commentsReplyMapArray,
                                                                  isReplyBool = :isReplyBool,
                                                                  likesArray = :likesArray
                                                                `,
                          expressionAttributeValues: {
                            ':commentsReplyMapArray': [],
                            ':isReplyBool': false,
                            ':likesArray': []
                          }
                        }
                      }).then(res => {
                        that.setState({
                          commentInitMediaFileName: null,
                          commentIsWritingMediaFileName: null
                        });
                      });
                    });
                  }
                }
              }} style={{
                borderColor: 'rgba(256, 256, 256, 1)',
                zIndex: 9999,
                position: 'static',
                fontSize: 16,
                lineHeight: 1.4,
                boxSizing: 'border-box',
                color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                borderRadius: 4,
                flexShrink: 0,
                width: 'auto',
                minWidth: 44,
                maxWidth: '100%',
                height: 44,
                minHeight: 44,
                padding: '8px 10px',
                margin: 0,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 6,
                backgroundColor: 'transparent',
                border: 0,
                boxShadow: 'none'
              }} className={'tbp-social-action ui button'}>                  
                                              <p style={{
                  textAlign: 'center',
                  textAlignVertical: 'top',
                  fontWeight: '600',
                  marginBottom: 5,
                  zIndex: 1,
                  boxSizing: 'border-box',
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  margin: '4px 0',
                  padding: 0,
                  width: 'auto',
                  height: 'auto',
                  fontSize: 14,
                  lineHeight: 1.5,
                  overflowWrap: 'break-word'
                }}> 
                                                {that.state.selectedLanguage == 'spanish' ? 'Comentar' : 'Comment'}
                                              </p>
                                            </Button>

                                          </div>

                                        </div> : null}

                                      {listItemA.commentsMapArray
          // true
          ? listItemA.commentsMapArray.map(listItemB => <div style={{
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
            // borderStyle: 'solid',
            ,

            boxSizing: 'border-box',
            marginTop: 0,
            marginBottom: 0,
            height: 'auto',
            minHeight: 0,
            width: '100%',
            minWidth: 0,
            maxWidth: '100%',
            position: 'static',
            margin: 0,
            padding: 0,
            gap: 8,
            display: 'block',
            overflow: 'visible',
            overflowX: 'visible',
            overflowY: 'visible'
          }} accessible={false}>
                                              <div style={{
              justifyContent: 'center',
              alignItems: 'center',
              // marginTop: listItemB.commentsReplyMapArray.length > 0 ? 75 : 25,
              marginBottom: 0,
              flexDirection: 'column'
              // borderStyle: 'solid',
              ,

              boxSizing: 'border-box',
              marginTop: 0,
              height: 'auto',
              minHeight: 0,
              width: '100%',
              minWidth: 0,
              maxWidth: '100%',
              position: 'static',
              margin: 0,
              padding: 0,
              gap: 8,
              display: 'block',
              overflow: 'visible',
              overflowX: 'visible',
              overflowY: 'visible'
            }} accessible={false}>
                                                <div style={{
                paddingTop: 6,
                // backgroundColor: 'purple',
                justifyContent: 'start',
                boxSizing: 'border-box',
                marginBottom: 0,
                flexDirection: 'row',
                height: 'auto',
                minHeight: 0,
                width: '100%',
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                padding: 0,
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible',
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                margin: '12px 0 4px'
              }} className={'tbp-comment-author'}>
                                                  <div style={{
                  borderRadius: 20,
                  zIndex: 1,
                  boxSizing: 'border-box',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  flexShrink: 0,
                  minHeight: 0,
                  minWidth: 0,
                  maxWidth: '100%',
                  position: 'static',
                  margin: 0,
                  padding: 0,
                  gap: 8,
                  display: 'block',
                  overflow: 'visible',
                  overflowX: 'visible',
                  overflowY: 'visible',
                  width: 32,
                  height: 32,
                  flex: '0 0 32px'
                }}>
                                                    <img style={{
                    borderStyle: 'solid',
                    borderColor: 'rgba(0, 0, 0, 1)',
                    borderWidth: 1

                    // objectFit: 'cover',
                    ,

                    position: 'static',
                    flexShrink: 0,
                    width: 32,
                    height: 32,
                    minWidth: 32,
                    maxWidth: 32,
                    maxHeight: 32,
                    objectFit: 'cover',
                    borderRadius: '50%',
                    border: '1px solid rgba(128,128,128,.3)',
                    margin: 0,
                    display: 'block'
                  }} src={listItemB.profilePictureURI} />
                                                  </div>
                                                  <div style={{
                  justifyContent: 'start',
                  zIndex: 1,
                  boxSizing: 'border-box',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  marginLeft: 0,
                  flex: 1,
                  height: 'auto',
                  minHeight: 0,
                  width: '100%',
                  minWidth: 0,
                  maxWidth: '100%',
                  position: 'static',
                  margin: 0,
                  padding: 0,
                  gap: 8,
                  display: 'block',
                  overflow: 'visible',
                  overflowX: 'visible',
                  overflowY: 'visible'
                }}>
                                                    <p style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'left',
                    textAlignVertical: 'top',
                    marginBottom: 7,
                    fontWeight: '600',
                    boxSizing: 'border-box',
                    marginLeft: 0,
                    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                    margin: '4px 0',
                    padding: 0,
                    width: 'auto',
                    height: 'auto',
                    fontSize: 14,
                    lineHeight: 1.5,
                    overflowWrap: 'break-word'
                  }}>
                                                      {`${String(listItemB.sender).toUpperCase()}`}
                                                    </p>
                                                  </div>
                                                  
                                
                                                </div>
                                                <p style={{
                // position: 'absolute',
                marginBottom: 5,
                top: 2,
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'left',
                textAlignVertical: 'top',
                marginLeft: 20,
                fontWeight: '400',
                paddingRight: 2,
                boxSizing: 'border-box',
                minHeight: 0,
                color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                margin: '4px 0',
                padding: 0,
                width: 'auto',
                height: 'auto',
                fontSize: 14,
                lineHeight: 1.5,
                overflowWrap: 'break-word'
              }}>
                                                  {`${listItemB.messageText}`}   
                                                  {/* qelfb wejv wejk vejwejv wejvw kwejqbgwe wefnb wej je ewjf e wej f ejwf jejee qwefjbu 2qui 2  2q b22fbu2 q2fbuq qwufib qwfuuwb iwhb  qubf quwfb quf uqwbf */}
                                                                                      
                                                </p><div style={{
                justifyContent: 'end',
                zIndex: 1,
                boxSizing: 'border-box',
                flexDirection: 'column',
                top: 'auto',
                left: 'auto',
                right: 'auto',
                bottom: 'auto',
                marginLeft: 0,
                flex: 1,
                height: 'auto',
                minHeight: 0,
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                padding: 0,
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 8,
                width: '100%',
                margin: '8px 0'
              }} className={'tbp-social-actions'}>
                                                    <Button onClick={() => {
                  let thisMessageID = listItemB.messageID;
                  that.setState({
                    newCommentStringInput: null,
                    commentReplyID: listItemB.messageID,
                    commentInitMediaFileName: null,
                    commentViewerMediaFileName: null
                  });
                }} style={{
                  zIndex: 1,
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  fontSize: 16,
                  lineHeight: 1.4,
                  boxSizing: 'border-box',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  borderRadius: 4,
                  flexShrink: 0,
                  width: 'auto',
                  minWidth: 44,
                  maxWidth: '100%',
                  height: 44,
                  minHeight: 44,
                  padding: '8px 10px',
                  margin: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  backgroundColor: 'transparent',
                  border: 0,
                  boxShadow: 'none'
                }} className={'tbp-social-action ui button'}>
                                                      <p style={{
                    textAlign: 'center',
                    zIndex: 1,
                    boxSizing: 'border-box',
                    position: 'static',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    margin: '4px 0',
                    padding: 0,
                    width: 'auto',
                    height: 'auto',
                    fontSize: 14,
                    lineHeight: 1.5,
                    overflowWrap: 'break-word'
                  }}>
                                                        <i className="pen square icon" size={25} style={{
                      color: 'rgba(0, 0, 0, 1)',
                      position: 'static',
                      fontSize: 20,
                      margin: 0,
                      width: 20,
                      height: 20,
                      lineHeight: 1,
                      flexShrink: 0
                    }} />
                                                      </p>
                                                    </Button>
                                                    <Button onClick={() => {
                  authenticatedPut('api1169ba1e', '', {
                    headers: {
                      Authorization: `Bearer ${cognitoID}`
                    },
                    body: {
                      category: 'db',
                      tableName: 'mediaUploadComments',
                      primaryKey: String(listItemB.messageID),
                      requestOperation: 'get'
                    }
                  }).then(mediaData => {
                    if (mediaData.hasOwnProperty('Item')) {
                      if (mediaData.Item.hasOwnProperty('likesArray')) {
                        let likesArray = mediaData.Item.likesArray;
                        if (likesArray.includes(currentUser.toLowerCase())) {
                          let indexToRemove = likesArray.indexOf(currentUser.toLowerCase());
                          likesArray.splice(indexToRemove, 1);
                          authenticatedPut('api1169ba1e', '', {
                            headers: {
                              Authorization: `Bearer ${cognitoID}`
                            },
                            body: {
                              category: 'db',
                              tableName: 'mediaUploadComments',
                              primaryKey: String(listItemB.messageID),
                              requestOperation: 'update',
                              updateExpression: `SET 
                                                                                likesArray = :likesArray
                                                                                `,
                              expressionAttributeValues: {
                                ':likesArray': likesArray
                              }
                            }
                          }).then(res => {
                            let likedMediaItemMap = that.state.likedMediaItemMap;
                            likedMediaItemMap[String(listItemB.mediaFileName)] = null;
                            that.setState({
                              likedMediaItemMap,
                              socialOverlay: false
                            }, () => {
                              that.setState({
                                socialOverlay: true
                              });
                            });
                          });
                        } else {
                          authenticatedPut('api1169ba1e', '', {
                            headers: {
                              Authorization: `Bearer ${cognitoID}`
                            },
                            body: {
                              category: 'db',
                              tableName: 'mediaUploadComments',
                              primaryKey: String(listItemB.messageID),
                              requestOperation: 'update',
                              updateExpression: `SET 
                                                                                  likesArray = list_append(likesArray, :currentUser)
                                                                                  `,
                              expressionAttributeValues: {
                                ':currentUser': [currentUser.toLowerCase()]
                              }
                            }
                          }).then(res => {
                            let likedMediaItemMap = that.state.likedMediaItemMap;
                            likedMediaItemMap[String(listItemB.mediaFileName)] = true;
                            that.setState({
                              likedMediaItemMap,
                              socialOverlay: false
                            }, () => {
                              that.setState({
                                socialOverlay: true
                              });
                            });
                          });
                        }
                      }
                    }
                  });
                }} style={{
                  zIndex: 1,
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  fontSize: 16,
                  lineHeight: 1.4,
                  boxSizing: 'border-box',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  borderRadius: 4,
                  flexShrink: 0,
                  width: 'auto',
                  minWidth: 44,
                  maxWidth: '100%',
                  height: 44,
                  minHeight: 44,
                  padding: '8px 10px',
                  margin: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  backgroundColor: 'transparent',
                  border: 0,
                  boxShadow: 'none'
                }} className={'tbp-social-action ui button'}>
                                                      <i className={listItemB.likesArray.includes(currentUser) ? "heart icon" : "heart outline icon"} size={20} style={{
                    color: 'rgba(204, 12, 12, 1)',
                    zIndex: 1,
                    position: 'static',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    fontSize: 20,
                    margin: 0,
                    width: 20,
                    height: 20,
                    lineHeight: 1,
                    flexShrink: 0
                  }} />
                                                      <div style={{
                    justifyContent: 'center',
                    alignItems: 'center'
                    // // borderWidth: 1,
                    ,

                    zIndex: 1,
                    boxSizing: 'border-box',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    height: 'auto',
                    minHeight: 0,
                    width: '100%',
                    minWidth: 0,
                    maxWidth: '100%',
                    position: 'static',
                    margin: 0,
                    padding: 0,
                    gap: 8,
                    display: 'block',
                    overflow: 'visible',
                    overflowX: 'visible',
                    overflowY: 'visible'
                  }}>
                                                        <p style={{
                      textAlign: 'left',
                      fontWeight: '600',
                      boxSizing: 'border-box',
                      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                      margin: '4px 0',
                      padding: 0,
                      width: 'auto',
                      height: 'auto',
                      fontSize: 14,
                      lineHeight: 1.5,
                      overflowWrap: 'break-word'
                    }}> 
                                                          {listItemB.likesArray ? listItemB.likesArray.length : null}
                                                          {/* 900 */}
                                                        </p>
                                                      </div>







                                                    </Button>
                                                  </div>
                                              </div>
                                  
                                            
                                              <div style={{
              justifyContent: 'center',
              alignItems: 'center',
              // backgroundColor: 'rgba(224, 225, 226, 1)',
              // backgroundColor: 'red',
              fontSize: 15,
              zIndex: 1,
              boxSizing: 'border-box',
              top: 'auto',
              left: 'auto',
              right: 'auto',
              bottom: 'auto',
              marginBottom: 0,
              height: 'auto',
              minHeight: 0,
              width: '100%',
              minWidth: 0,
              maxWidth: '100%',
              position: 'static',
              margin: 0,
              padding: 0,
              gap: 8,
              display: 'block',
              overflow: 'visible',
              overflowX: 'visible',
              overflowY: 'visible'
            }}>   

                                                {that.state.commentReplyID == listItemB.messageID
              // true
              ? <div style={{
                marginTop: 10,
                zIndex: 1,
                boxSizing: 'border-box',
                top: 'auto',
                left: 'auto',
                right: 'auto',
                bottom: 'auto',
                marginBottom: 0,
                height: 'auto',
                minHeight: 0,
                width: '100%',
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                margin: 0,
                padding: 0,
                gap: 8,
                display: 'block',
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible'
              }}> 
                                                    <input autocomplete="off" type="text" id="textCommentReply"
                // className="loginInput"  
                value={that.state.newCommentStringInput} onChange={event => {
                  that.setState({
                    newCommentStringInput: event.target.value
                  });
                }} name="text" maxLength='100' placeholder={that.state.selectedLanguage == 'spanish' ? 'Drop a Comment' : 'Comentar'} placeholderTextColor={'rgba(0, 0, 0, 1)'} style={{
                  marginLeft: 0,
                  justifyContent: 'center',
                  alignContent: 'center',
                  alignSelf: 'center',
                  textAlign: 'left',
                  textAlignVertical: 'center',
                  opacity: 0.95,
                  fontWeight: '600',
                  marginBottom: 0,
                  paddingRight: 4,
                  height: 'auto',
                  paddingLeft: 16,
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  maxWidth: '100%',
                  backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
                  border: '1px solid rgba(128,128,128,.4)',
                  borderRadius: 4,
                  boxSizing: 'border-box',
                  width: '100%',
                  fontSize: 16,
                  padding: 12,
                  minHeight: 44,
                  margin: '8px 0'
                }} />
                                                    
                                                    <div style={{
                  // paddingLeft: '50',
                  marginBottom: 0,
                  paddingBottom: 5,
                  flexDirection: 'row',
                  justifyContent: 'end',
                  boxSizing: 'border-box',
                  marginLeft: 0,
                  height: 'auto',
                  minHeight: 0,
                  minWidth: 0,
                  maxWidth: '100%',
                  position: 'static',
                  padding: 0,
                  overflow: 'visible',
                  overflowX: 'visible',
                  overflowY: 'visible',
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  gap: 8,
                  width: '100%',
                  margin: '8px 0'
                }} className={'tbp-social-actions'}>
                                                      <Button onClick={() => {
                    that.setState({
                      newCommentStringInput: null,
                      commentReplyID: null,
                      commentInitMediaFileName: null,
                      commentIsWritingMediaFileName: null
                    });
                  }} style={{
                    borderColor: 'rgba(256, 256, 256, 1)',
                    zIndex: 9999,
                    position: 'static',
                    fontSize: 16,
                    lineHeight: 1.4,
                    boxSizing: 'border-box',
                    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                    borderRadius: 4,
                    flexShrink: 0,
                    width: 'auto',
                    minWidth: 44,
                    maxWidth: '100%',
                    height: 44,
                    minHeight: 44,
                    padding: '8px 10px',
                    margin: 0,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    backgroundColor: 'transparent',
                    border: 0,
                    boxShadow: 'none'
                  }} className={'tbp-social-action ui button'}>                  
                                                        <p style={{
                      textAlign: 'center',
                      textAlignVertical: 'top',
                      fontWeight: '600',
                      marginBottom: 5,
                      zIndex: 1,
                      boxSizing: 'border-box',
                      position: 'static',
                      top: 'auto',
                      left: 'auto',
                      right: 'auto',
                      bottom: 'auto',
                      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                      margin: '4px 0',
                      padding: 0,
                      width: 'auto',
                      height: 'auto',
                      fontSize: 14,
                      lineHeight: 1.5,
                      overflowWrap: 'break-word'
                    }}> 
                                                        {that.state.selectedLanguage == 'spanish' ? 'Borrar' : 'Discard'}
                                                        </p>
                                                      </Button>
                                                      <Button onClick={() => {
                    var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                    randomString1 = String(currentUser).concat(randomString1.substring(0, 18));
                    authenticatedPut('api1169ba1e', '', {
                      headers: {
                        Authorization: `Bearer ${cognitoID}`
                      },
                      body: {
                        category: 'db',
                        tableName: 'mediaUploadComments',
                        primaryKey: listItemB.messageID,
                        requestOperation: 'update',
                        updateExpression: `SET 
                                                                      commentsReplyMapArray = list_append(commentsReplyMapArray, :newCommentReplyMap)
                                                                    `,
                        expressionAttributeValues: {
                          ':newCommentReplyMap': [{
                            sender: currentUser.toLowerCase(),
                            sentTimestamp: Date.now(),
                            messageText: String(that.state.newCommentStringInput),
                            messageID: randomString1,
                            rootMessageID: listItemB.messageID,
                            likesArray: []
                          }]
                        }
                      }
                    }).then(res => {
                      that.setState({
                        newCommentStringInput: null,
                        commentReplyID: null
                      });
                    });
                  }} style={{
                    borderColor: 'rgba(256, 256, 256, 1)',
                    zIndex: 9999,
                    position: 'static',
                    fontSize: 16,
                    lineHeight: 1.4,
                    boxSizing: 'border-box',
                    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                    borderRadius: 4,
                    flexShrink: 0,
                    width: 'auto',
                    minWidth: 44,
                    maxWidth: '100%',
                    height: 44,
                    minHeight: 44,
                    padding: '8px 10px',
                    margin: 0,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    backgroundColor: 'transparent',
                    border: 0,
                    boxShadow: 'none'
                  }} className={'tbp-social-action ui button'}>                  
                                                        <p style={{
                      textAlign: 'center',
                      textAlignVertical: 'top',
                      fontWeight: '600',
                      marginBottom: 5,
                      zIndex: 1,
                      boxSizing: 'border-box',
                      position: 'static',
                      top: 'auto',
                      left: 'auto',
                      right: 'auto',
                      bottom: 'auto',
                      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                      margin: '4px 0',
                      padding: 0,
                      width: 'auto',
                      height: 'auto',
                      fontSize: 14,
                      lineHeight: 1.5,
                      overflowWrap: 'break-word'
                    }}> 
                                                          {that.state.selectedLanguage == 'spanish' ? 'Contestar' : 'Reply'}
                                                        </p>
                                                      </Button>

                                                    </div>

                                                  </div> : null}











                                              </div>              
                                                













































                                              


















































                                              {listItemB.commentsReplyMapArray.length > 0 ? <div style={{
              // justifyContent: 'center',
              // alignItems: 'center',
              // position: 'absolute',
              // top: 0,
              borderColor: 'red',
              // bottom: 35,
              marginTop: 0,
              // display: 'flex',
              // flex: 1,
              // flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
              // paddingTop: 10,
              ,

              zIndex: 1,
              boxSizing: 'border-box',
              top: 'auto',
              left: 'auto',
              right: 'auto',
              bottom: 'auto',
              height: 'auto',
              minHeight: 0,
              width: '100%',
              minWidth: 0,
              maxWidth: '100%',
              position: 'static',
              margin: 0,
              padding: 0,
              gap: 8,
              display: 'block',
              overflow: 'visible',
              overflowX: 'visible',
              overflowY: 'visible'
            }}>
                                                  
                                                  {listItemB.commentsReplyMapArray.length > 0 ? <div style={{
                // borderBottomStyle: 'solid',
                borderWidth: 1,
                paddingTop: 0,
                // paddingBottom: 50,
                // borderColor: 'green',
                // justifyContent: 'center',
                // alignItems: 'center',
                // position: 'relative',
                top: 0,
                marginTop: 3,
                marginBottom: 0,
                // maxHeight: 215,
                // // backgroundColor: 'green',
                // display: 'flex',
                // flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
                // paddingTop: 10,
                ,

                boxSizing: 'border-box',
                height: 'auto',
                minHeight: 0,
                width: '100%',
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                margin: 0,
                padding: 0,
                gap: 8,
                display: 'block',
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible'
              }}>

                                                      <React.Fragment style={{}}> 
                                                        {listItemB.commentsReplyMapArray.map(listItemE => <div style={{
                    zIndex: 99999,
                    // display: 'flex',
                    // flexDirection: 'column',
                    // backgroundColor: 'red',
                    justifyContent: 'center',
                    // borderBottomWidth: 0.5,
                    // marginBottom: 30,
                    borderColor: 'black',
                    boxSizing: 'border-box',
                    height: 'auto',
                    minHeight: 0,
                    width: '100%',
                    minWidth: 0,
                    maxWidth: '100%',
                    position: 'static',
                    padding: 0,
                    overflow: 'visible',
                    overflowX: 'visible',
                    overflowY: 'visible',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    margin: '12px 0 4px'
                  }} accessible={false} className={'tbp-comment-author'}>
                                                            


                                                            <div style={{
                      justifyContent: 'center',
                      marginRight: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      zIndex: 1,
                      boxSizing: 'border-box',
                      flexDirection: 'column',
                      top: 'auto',
                      left: 'auto',
                      right: 'auto',
                      bottom: 'auto',
                      marginBottom: 0,
                      minHeight: 0,
                      minWidth: 0,
                      maxWidth: '100%',
                      position: 'static',
                      padding: 0,
                      overflow: 'visible',
                      overflowX: 'visible',
                      overflowY: 'visible',
                      height: 32,
                      flex: '0 0 32px',
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      gap: 8,
                      width: '100%',
                      margin: '8px 0'
                    }} className={'tbp-social-actions'}>
                                                              <img style={{
                        borderStyle: 'solid',
                        borderColor: 'rgba(0, 0, 0, 1)',
                        borderWidth: 1,
                        zIndex: 1,
                        position: 'static',
                        top: 'auto',
                        left: 'auto',
                        right: 'auto',
                        bottom: 'auto',
                        flexShrink: 0,
                        width: 32,
                        height: 32,
                        minWidth: 32,
                        maxWidth: 32,
                        maxHeight: 32,
                        objectFit: 'cover',
                        borderRadius: '50%',
                        border: '1px solid rgba(128,128,128,.3)',
                        margin: 0,
                        display: 'block'
                      }} src={listItemE.profilePictureURI} />

                                                              <div style={{
                        // minHeight: 38,
                        // justifyContent: 'center', 
                        // alignItems: 'center', 
                        textAlign: 'left',
                        textAlignVertical: 'top',
                        fontSize: 12,
                        fontWeight: '400',
                        zIndex: 1,
                        boxSizing: 'border-box',
                        lineHeight: 1.5,
                        overflowWrap: 'anywhere',
                        top: 'auto',
                        left: 'auto',
                        right: 'auto',
                        bottom: 'auto',
                        marginLeft: 0,
                        marginRight: 0,
                        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                        height: 'auto',
                        minHeight: 0,
                        width: '100%',
                        minWidth: 0,
                        maxWidth: '100%',
                        position: 'static',
                        margin: 0,
                        padding: 0,
                        gap: 8,
                        display: 'block',
                        overflow: 'visible',
                        overflowX: 'visible',
                        overflowY: 'visible'
                      }}>
                                                                <p style={{
                          // position: 'relative',
                          // // left: 55, 
                          marginLeft: 0,
                          // top: -40,
                          // width: '25vw',
                          // minHeight: 38,
                          // justifyContent: 'center', 
                          // alignItems: 'center', 
                          textAlign: 'left',
                          textAlignVertical: 'top',
                          marginBottom: 7,
                          // fontSize: 10, 
                          // color: 'rgba(0, 0, 0, 1)',
                          fontWeight: '600',
                          boxSizing: 'border-box',
                          margin: '4px 0',
                          padding: 0,
                          width: 'auto',
                          height: 'auto',
                          fontSize: 14,
                          lineHeight: 1.5,
                          overflowWrap: 'break-word'
                        }}>
                                                                  {`${String(listItemE.sender).toUpperCase()}`}
                                                                </p>
                                                                {`${listItemE.messageText}`}
                                                                {/* qelfb wejv wejk vejwejv wejvw kwejqbgwe wefnb wej je ewjf e wej f ejwf jejee qwefjbu 2qui 2  2q b22fbu2 q2fbuq qwufib qwfuuwb iwhb  qubf quwfb quf uqwbf */}
                                                              </div>
                                                                
                                                            


                                                            
















                                                            
                                                              
                                                              <Button onClick={() => {
                        let likesArray = [];
                        authenticatedPut('api1169ba1e', '', {
                          headers: {
                            Authorization: `Bearer ${cognitoID}`
                          },
                          body: {
                            category: 'db',
                            tableName: 'mediaUploadComments',
                            primaryKey: String(listItemE.rootMessageID),
                            requestOperation: 'get'
                          }
                        }).then(commentData => {
                          if (commentData.hasOwnProperty('Item')) {
                            if (commentData.Item.hasOwnProperty('commentsReplyMapArray')) {
                              let commentsReplyMapArray = commentData.Item.commentsReplyMapArray;
                              function loopCommentsReplyArray(r) {
                                if (commentsReplyMapArray.length - 1 >= r && commentsReplyMapArray.length > 0) {
                                  let thisReply = commentsReplyMapArray[r];
                                  let likesArray = thisReply.likesArray;
                                  if (likesArray.includes(currentUser.toLowerCase())) {
                                    likesArray.splice(r, 1);
                                    commentsReplyMapArray[r].likesArray = likesArray;
                                    authenticatedPut('api1169ba1e', '', {
                                      headers: {
                                        Authorization: `Bearer ${cognitoID}`
                                      },
                                      body: {
                                        category: 'db',
                                        tableName: 'mediaUploadComments',
                                        primaryKey: String(listItemE.rootMessageID),
                                        requestOperation: 'update',
                                        updateExpression: `SET 
                                                                                          commentsReplyMapArray = :commentsReplyMapArray
                                                                                        `,
                                        expressionAttributeValues: {
                                          ':commentsReplyMapArray': commentsReplyMapArray
                                        }
                                      }
                                    }).then(res => {
                                      let likedMediaItemMap = that.state.likedMediaItemMap;
                                      likedMediaItemMap[String(listItemE.mediaFileName)] = null;
                                      that.setState({
                                        likedMediaItemMap,
                                        socialOverlay: false
                                      }, () => {
                                        that.setState({
                                          socialOverlay: true
                                        });
                                      });
                                    });
                                  } else {
                                    if (commentsReplyMapArray.length - 1 == r) {
                                      let thisReply = commentsReplyMapArray[r];
                                      let likesArray = thisReply.likesArray;
                                      likesArray.push(currentUser.toLowerCase());
                                      commentsReplyMapArray[r].likesArray = likesArray;
                                      authenticatedPut('api1169ba1e', '', {
                                        headers: {
                                          Authorization: `Bearer ${cognitoID}`
                                        },
                                        body: {
                                          category: 'db',
                                          tableName: 'mediaUploadComments',
                                          primaryKey: String(listItemE.rootMessageID),
                                          requestOperation: 'update',
                                          updateExpression: `SET 
                                                                                            commentsReplyMapArray = :commentsReplyMapArray
                                                                                          `,
                                          expressionAttributeValues: {
                                            ':commentsReplyMapArray': commentsReplyMapArray
                                          }
                                        }
                                      }).then(res => {
                                        let likedMediaItemMap = that.state.likedMediaItemMap;
                                        likedMediaItemMap[String(listItemE.mediaFileName)] = true;
                                        that.setState({
                                          likedMediaItemMap,
                                          socialOverlay: false
                                        }, () => {
                                          that.setState({
                                            socialOverlay: true
                                          });
                                        });
                                      });
                                    } else {
                                      loopCommentsReplyArray(r + 1);
                                    }
                                  }
                                }
                              }
                              loopCommentsReplyArray(0);
                            }
                          }
                        });
                      }} style={{
                        zIndex: 1,
                        position: 'static',
                        top: 'auto',
                        left: 'auto',
                        right: 'auto',
                        bottom: 'auto',
                        marginLeft: 0,
                        fontSize: 16,
                        lineHeight: 1.4,
                        boxSizing: 'border-box',
                        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                        borderRadius: 4,
                        flexShrink: 0,
                        width: 'auto',
                        minWidth: 44,
                        maxWidth: '100%',
                        height: 44,
                        minHeight: 44,
                        padding: '8px 10px',
                        margin: 0,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 6,
                        backgroundColor: 'transparent',
                        border: 0,
                        boxShadow: 'none'
                      }} className={'tbp-social-action ui button'}>
                                                                <i className={listItemE.likesArray.includes(currentUser) ? "heart icon" : "heart outline icon"} size={14} style={{
                          color: 'rgba(204, 12, 12, 1)',
                          zIndex: 1,
                          position: 'static',
                          top: 'auto',
                          left: 'auto',
                          right: 'auto',
                          bottom: 'auto',
                          fontSize: 20,
                          margin: 0,
                          width: 20,
                          height: 20,
                          lineHeight: 1,
                          flexShrink: 0
                        }} />
                                                                <div style={{
                          justifyContent: 'center',
                          alignItems: 'center'
                          // // borderWidth: 1,
                          ,

                          zIndex: 1,
                          boxSizing: 'border-box',
                          top: 'auto',
                          left: 'auto',
                          right: 'auto',
                          bottom: 'auto',
                          height: 'auto',
                          minHeight: 0,
                          width: '100%',
                          minWidth: 0,
                          maxWidth: '100%',
                          position: 'static',
                          margin: 0,
                          padding: 0,
                          gap: 8,
                          display: 'block',
                          overflow: 'visible',
                          overflowX: 'visible',
                          overflowY: 'visible'
                        }}>
                                                                  <p style={{
                            textAlign: 'left',
                            fontWeight: '600',
                            boxSizing: 'border-box',
                            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                            margin: '4px 0',
                            padding: 0,
                            width: 'auto',
                            height: 'auto',
                            fontSize: 14,
                            lineHeight: 1.5,
                            overflowWrap: 'break-word'
                          }}> 
                                                                    {listItemE.likesArray ? listItemE.likesArray.length : null}
                                                                  {/* 900 */}
                                                                  </p>
                                                                </div>

                                                              </Button>
                                                            </div>
















                                                          </div>)}
                                                      </React.Fragment>

                                                    </div> : null}
                                                </div> : null}
                                              






































                                            </div>) : null}




                                    </div>



















                                    
                                  </div>) : null}</div></div>

            </Modal>
         
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.generalNoticeTimedOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>
                
              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                  <Header style={{
        fontSize: 16,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginRight: 0,
        height: 'auto',
        width: '100%',
        margin: 0,
        lineHeight: 1.5
      }}>{`${that.state.generalNoticeText}`}</Header>
                  
                </Modal.Description>
                
              </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.generalNoticeOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>
                
              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                  <Header style={{
        fontSize: 16,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginRight: 0,
        height: 'auto',
        width: '100%',
        margin: 0,
        lineHeight: 1.5
      }}>{`${that.state.generalNoticeText}`}</Header>
                  <Button content="Okay" labelPosition='right' icon='checkmark' onClick={() => {
        that.setState({
          generalNoticeOverlay: false
        });
      }} positive style={{
        backgroundColor: 'rgba(0, 158, 129, 1)',
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }} />
                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.renameCreditLineOverlay && !that.state.isSubscribedCurrentBool}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                    
                    <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                      The Blender Platform
                    </p>
                </Modal.Header>
                
                  
                <div style={{
    marginTop: 20,
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: '100%'
  }}>
                  <div style={{
      fontWeight: '600',
      textAlign: 'center',
      marginBottom: 0,
      top: 5,
      fontSize: 20,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    {that.state.selectedLanguage == 'spanish' ? 'Suscríbase a ' : 'Subscribe to '}
                    <p style={{
        fontWeight: '600',
        textAlign: 'center',
        marginBottom: 0,
        top: 5,
        fontSize: 20,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'anywhere'
      }}>
                      {'Blender Pro Plus'}
                    </p>
                  </div>
                  
                  <p style={{
      fontSize: 20,
      fontWeight: '600',
      textAlign: 'center',
      marginLeft: 20,
      marginRight: 20,
      textShadowColor: 'rgba(0, 0, 0, 0.10)',
      textShadowOffset: {
        width: -1,
        height: 1
      },
      textShadowRadius: 10,
      marginTop: 0,
      marginBottom: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    {that.state.selectedLanguage == 'spanish' ? 'Exclusiva por Blender Pro Plus' : 'Exclusive for Blender Pro Plus'}
                  </p>
                
                  <div style={{
      marginTop: 15,
      marginBottom: 0,
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      display: 'flex'
    }}>
                  
                      <Button onClick={() => {
        that.setState({
          renameCreditLineOverlay: false
        });
      }} style={{
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 5,
        borderColor: 'rgba(0, 158, 129, 1)',
        borderRadius: 5,
        backgroundColor: 'rgba(0, 158, 129, 1)',
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'auto',
        width: '100%',
        marginTop: 0,
        marginBottom: 0,
        position: 'static',
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }}>                  
                        <p style={{
          fontSize: 20,
          textAlign: 'center',
          fontWeight: '600',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}> 
                          {that.state.selectedLanguage == 'spanish' ? 'Blender Pro Plus' : 'Blender Pro Plus'}
                        </p>
                      </Button>
                      <Button onClick={() => {
        that.setState({
          renameCreditLineOverlay: false
        });
      }} style={{
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 5,
        borderColor: 'rgba(256, 256, 256, 1)',
        borderRadius: 5,
        backgroundColor: 'rgba(0, 158, 129, 0.08)',
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'auto',
        width: '100%',
        marginBottom: 0,
        position: 'static',
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }}>                  
                        <p style={{
          fontSize: 16,
          textAlign: 'center',
          fontWeight: '600',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}> 
                          {that.state.selectedLanguage == 'spanish' ? 'Cerrar' : 'Close'}
                        </p>
                      </Button>

                    </div>
                    
                </div>
                
            </Modal>
            
            
 
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.statExplanationOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>
                          

            <div style={{
    fontWeight: '600',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'static',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    width: '100%',
    marginLeft: 0,
    marginRight: 0
  }}>
              <div style={{
      top: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'left',
      height: 'auto',
      width: '100%',
      marginTop: 0
    }}>
                <p style={{
        fontSize: 16,
        fontWeight: '600',
        textAlign: 'left',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'anywhere'
      }}>
                  {that.state.statName}
                </p>
                <p style={{
        fontSize: 16,
        fontWeight: '600',
        textAlign: 'left',
        height: 'auto',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'anywhere'
      }}>
                  {that.state.statDesc}
                </p>
              </div>

              <p style={{
      fontSize: 22,
      fontWeight: '600',
      textAlign: 'center',
      textShadowColor: 'rgba(0, 0, 0, 0.10)',
      textShadowOffset: {
        width: -1,
        height: 1
      },
      textShadowRadius: 10,
      marginTop: 0,
      marginBottom: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                {that.state.statValue}
              </p>

            </div>
            
            <div style={{
    // flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'static',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    width: '100%'
  }}>
              <Button content="Okay" labelPosition='right' icon='checkmark' onClick={() => {
      that.setState({
        statExplanationOverlay: false
      });
    }} positive style={{
      backgroundColor: 'rgba(0, 158, 129, 1)',
      position: 'static',
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
      minHeight: 44,
      fontSize: 16,
      lineHeight: 1.4,
      boxSizing: 'border-box',
      margin: 0,
      padding: '12px 16px',
      maxWidth: '100%',
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
    }} />
            </div>
              
            </Modal>
 
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.fundWalletPromptOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>
                
              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                  <Header style={{
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginTop: 0,
        marginRight: 0,
        height: 'auto',
        width: '100%',
        margin: 0,
        lineHeight: 1.5
      }}>
                    <div style={{
          fontSize: 18,
          fontWeight: '600',
          textAlign: 'left',
          textShadowColor: 'rgba(0, 0, 0, 0.10)',
          textShadowOffset: {
            width: -1,
            height: 1
          },
          textShadowRadius: 10,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                      {that.state.selectedLanguage == 'spanish' ? 'Valor Bajo de Carter Blender\n\n' : 'Low Blender Wallet Balance\n\n'}
                      <p style={{
            fontSize: 15,
            fontWeight: '600',
            textAlign: 'left',
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere'
          }}>
                        {that.state.selectedLanguage == 'spanish' ? 'Querías depositar\npor su tarjeta de banco?' : 'Would you like to top-up\nusing your debit card?'}
                      </p>
                  
                    </div>
                  </Header>




                  <div style={{
        flexDirection: 'row',
        justifyContent: 'center',
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto'
      }}>
                  
                    <Button content={that.state.selectedLanguage == 'spanish' ? 'Depositar Fondos' : 'Deposit Funds'} labelPosition='right' icon='checkmark' onClick={() => {
          that.setState({
            fundWalletPromptOverlay: false,
            inProcessLoading: true
          });
        }} positive style={{
          // marginLeft: 25,
          backgroundColor: 'rgba(0, 158, 129, 1)',
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%'
        }} />
                    <Button content={that.state.selectedLanguage == 'spanish' ? 'No' : 'No'} labelPosition='right' icon='close' onClick={() => {
          that.setState({
            fundWalletPromptOverlay: false
          });
        }} positive style={{
          backgroundColor: 'rgba(204, 12, 12, 1)',
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%'
        }} />
                  </div>

                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.activityIndicator ? true : false}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>

              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                    <Header style={{
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        height: 'auto',
        width: '100%',
        position: 'static',
        margin: 0,
        lineHeight: 1.5
      }}>
                        <div className="tbp-overlay-loading" style={{}}><ThreeDot color="rgba(0, 158, 129, 1)" size="large" style={{
            maxWidth: '50px',
            speedPlus: -2
          }} /></div>
                    </Header>
                    
                </Modal.Description>
                
              </Modal.Content>
            </Modal>

            <Modal
              centered={true}
              dimmer={{ className: "tbp-overlay-backdrop" }}
              className={
                "tbp-overlay " +
                (that.state.mode_light_dark == "light" ? "light" : "dark") +
                " tbp-mobile-dialog tbp-borrow-mobile-page-loader"
              }
              open={that.state.showPageLoader}
              style={{
                width: 'calc(100% - 24px)',
                maxWidth: 520,
                height: 'auto',
                maxHeight: 'calc(100dvh - 24px)',
                overflowY: 'auto',
                overflowX: 'hidden',
                padding: 0,
                margin: '12px auto',
                borderRadius: 16,
                boxSizing: 'border-box',
                backgroundColor: that.state.mode_light_dark == 'light'
                  ? '#f8fbff'
                  : '#172b41',
                color: that.state.mode_light_dark == 'light'
                  ? '#20384b'
                  : '#e9f3fc',
                border: that.state.mode_light_dark == 'light'
                  ? '1px solid #cbdce9'
                  : '1px solid #3b526c',
                boxShadow: '0 16px 45px rgba(0, 0, 0, 0.40)'
              }}
            >
              <Modal.Content
                style={{
                  padding: 0,
                  backgroundColor: 'transparent'
                }}
              >
                <div
                  style={{
                    padding: '20px 16px 22px',
                    boxSizing: 'border-box'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 10,
                      marginBottom: 14
                    }}
                  >
                    <div
                      style={{
                        color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                        fontSize: 21,
                        fontWeight: '700',
                        textAlign: 'center'
                      }}
                    >
                      {that.state.selectedLanguage == 'spanish'
                        ? 'Explora The Blender Platform'
                        : 'Explore The Blender Platform'}
                    </div>
                  </div>

                  <div
                    style={{
                      textAlign: 'center',
                      fontSize: 14,
                      fontWeight: '600',
                      marginBottom: 18,
                      color: that.state.mode_light_dark == 'light'
                        ? 'rgba(55, 55, 55, 1)'
                        : 'rgba(220, 220, 220, 1)'
                    }}
                  >
                    {that.state.selectedLanguage == 'spanish'
                      ? 'Presta • Pide Prestado • Apuesta'
                      : 'Lend • Borrow • Stake'}
                  </div>

                  <div className="tbp-borrow-mobile-loader-info"
                    style={{
                      borderRadius: 15,
                      border: that.state.mode_light_dark == 'light'
                        ? '1px solid #cbdce9'
                        : '1px solid #3b526c',
                      backgroundColor: that.state.mode_light_dark == 'light'
                        ? '#edf4fa'
                        : '#20364e',
                      padding: '16px 14px'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 12
                      }}
                    >
                      <div
                        style={{
                          width: 42,
                          height: 42,
                          minWidth: 42,
                          minWidth: 48,
                          minHeight: 48,
                          flexShrink: 0,
                          borderRadius: 24,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                          fontSize: 21
                        }}
                      >
                        <i className="chart line icon" />
                      </div>

                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                            fontSize: 16,
                            fontWeight: '700',
                            marginBottom: 4
                          }}
                        >
                          {that.state.selectedLanguage == 'spanish' ? 'PRESTAR' : 'LEND'}
                        </div>

                        <div
                          style={{
                            color: that.state.mode_light_dark == 'light'
                              ? '#20384b'
                              : '#eaf4fc',
                            fontSize: 13,
                            lineHeight: 1.45,
                            fontWeight: '500'
                          }}
                        >
                          {that.state.selectedLanguage == 'spanish'
                            ? 'Compara tasas de interés, actividad y estadísticas de pago antes de elegir una línea de crédito. Los fondos aún no retirados pueden seguir siendo reclamables.'
                            : 'Compare interest rates, activity and repayment statistics before choosing a credit-line. Funds not yet withdrawn may remain reclaimable.'}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        height: 1,
                        margin: '14px 0',
                        backgroundColor: that.state.mode_light_dark == 'light'
                          ? 'rgba(0, 0, 0, 0.08)'
                          : 'rgba(255, 255, 255, 0.10)'
                      }}
                    />

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 12
                      }}
                    >
                      <div
                        style={{
                          width: 42,
                          height: 42,
                          minWidth: 42,
                          minWidth: 48,
                          minHeight: 48,
                          flexShrink: 0,
                          borderRadius: 24,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                          fontSize: 19
                        }}
                      >
                        <i className="credit card outline icon" />
                      </div>

                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                            fontSize: 16,
                            fontWeight: '700',
                            marginBottom: 4
                          }}
                        >
                          {that.state.selectedLanguage == 'spanish'
                            ? 'PEDIR PRESTADO'
                            : 'BORROW'}
                        </div>

                        <div
                          style={{
                            color: that.state.mode_light_dark == 'light'
                              ? '#20384b'
                              : '#eaf4fc',
                            fontSize: 13,
                            lineHeight: 1.45,
                            fontWeight: '500'
                          }}
                        >
                          {that.state.selectedLanguage == 'spanish'
                            ? 'Tu crédito disponible depende de los fondos aportados y el colateral de tu línea. Retira crédito disponible y repaga deuda desde tu Blender Wallet.'
                            : 'Your available credit depends on contributed funds and collateral in your line. Withdraw available credit and repay debt from your Blender Wallet.'}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        height: 1,
                        margin: '14px 0',
                        backgroundColor: that.state.mode_light_dark == 'light'
                          ? 'rgba(0, 0, 0, 0.08)'
                          : 'rgba(255, 255, 255, 0.10)'
                      }}
                    />

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 12
                      }}
                    >
                      <div
                        style={{
                          width: 42,
                          height: 42,
                          minWidth: 42,
                          minWidth: 48,
                          minHeight: 48,
                          flexShrink: 0,
                          borderRadius: 24,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                          fontSize: 20
                        }}
                      >
                        <i className="shield alternate icon" />
                      </div>

                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                            fontSize: 16,
                            fontWeight: '700',
                            marginBottom: 4
                          }}
                        >
                          {that.state.selectedLanguage == 'spanish'
                            ? 'APOSTAR'
                            : 'STAKE'}
                        </div>

                        <div
                          style={{
                            color: that.state.mode_light_dark == 'light'
                              ? '#20384b'
                              : '#eaf4fc',
                            fontSize: 13,
                            lineHeight: 1.45,
                            fontWeight: '500'
                          }}
                        >
                          {that.state.selectedLanguage == 'spanish'
                            ? 'Aporta colateral a una línea de crédito y recibe comisiones elegibles generadas por la actividad procesada en esa línea.'
                            : 'Provide collateral to a credit-line and receive eligible commissions generated by activity processed through that line.'}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tbp-borrow-mobile-loader-tip"
                    style={{
                      marginTop: 14,
                      padding: '13px 14px',
                      borderRadius: 13,
                      border: that.state.mode_light_dark == 'light'
                        ? '1px solid #cbdce9'
                        : '1px solid #3b526c',
                      backgroundColor: that.state.mode_light_dark == 'light'
                        ? '#edf4fa'
                        : '#20364e',
                      textAlign: 'center'
                    }}
                  >
                    <div
                      style={{
                        color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                        fontSize: 13,
                        fontWeight: '700',
                        marginBottom: 5
                      }}
                    >
                      {that.state.selectedLanguage == 'spanish'
                        ? '¿SABÍAS QUE?'
                        : 'DID YOU KNOW?'}
                    </div>

                    <div
                      style={{
                        color: that.state.mode_light_dark == 'light'
                          ? '#20384b'
                          : '#eaf4fc',
                        fontSize: 12.5,
                        lineHeight: 1.45,
                        fontWeight: '500'
                      }}
                    >
                      {that.state.selectedLanguage == 'spanish'
                        ? 'Puedes revisar la actividad, deuda, tasas y estadísticas de una línea de crédito antes de prestar o apostar fondos.'
                        : 'You can review activity, debt, rates and credit-line statistics before deciding whether to lend or stake funds.'}
                    </div>
                  </div>

                  <div
                    style={{
                      marginTop: 14,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 8,
                      color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                      fontSize: 13,
                      fontWeight: '700'
                    }}
                  >
                    <div
                      style={{
                        width: 16,
                        height: 16,
                        borderRadius: '50%',
                        border: '2px solid #3b526c',
                        borderTopColor: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                        animation: 'tbpSpin 0.9s linear infinite'
                      }}
                    />

                    {that.state.selectedLanguage == 'spanish'
                      ? 'Cargando Línea de Crédito'
                      : 'Loading Credit-Line'}
                  </div>

                  <style>
                    {`
                      @keyframes tbpSpin {
                        from { transform: rotate(0deg); }
                        to { transform: rotate(360deg); }
                      }
                    `}
                  </style>
                </div>
              </Modal.Content>
            </Modal>
                        
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={'tbp-mobile-navigation ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark') + ' tbp-mobile-dialog'} open={that.state.navigationOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <div className="tbp-mobile-menu-panel" style={{
    // borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '8vh',
    borderRightStyle: 'solid',
    borderWidth: 0.1,
    borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
    padding: '20px',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
    border: 0,
    boxSizing: 'border-box',
    position: 'static',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '100%'
  }}><div style={{
      justifyContent: "space-between",
      marginBottom: 24,
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      margin: '0 0 20px',
      width: '100%'
    }} className={'tbp-menu-header'}><div style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        textAlign: 'left',
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        flex: 1,
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        width: 'auto',
        minWidth: 0
      }} className={'tbp-menu-brand'}> 
                  <div style={{
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 12,
          width: 'auto',
          minWidth: 0
        }}>
                    <img src={'https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png'} style={{
            left: '4vw',
            paddingRight: '2vw',
            // position: 'absolute',
            borderRadius: '0.5',
            weight: '3vh',
            position: 'static',
            flexShrink: 0,
            width: 28,
            height: 28,
            flex: '0 0 28px',
            padding: 0,
            margin: 0
          }} />
                    <p style={{
            textAlign: 'left',
            // marginBottom: 5,
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 0,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            flex: 1,
            minWidth: 0,
            width: 'auto',
            fontSize: 16,
            lineHeight: 1.4,
            overflowWrap: 'normal',
            wordBreak: 'normal',
            margin: 0
          }}>
                      {'The Blender Platform'}
                        <span className="tbp-menu-username" title={String(currentUser || that.state.currentUser || '')}>{'@' + String(currentUser || that.state.currentUser || '').replace(/^@/, '')}</span>
                    </p>
                  </div>

                </div><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        flexShrink: 0,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        minHeight: 44,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        width: 44,
        height: 44,
        flex: '0 0 44px',
        padding: 0,
        margin: 0
      }} onClick={() => {
        that.setState({
          navigationOverlay: false
        });
      }}> 
                  <svg className="tbp-mobile-menu-close-svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 5L19 19M19 5L5 19" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" /></svg>
                </Button></div><List className="tbp-mobile-menu-list" style={{
      justifyContent: 'space-between',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      alignItems: 'stretch',
      height: 'auto',
      width: '100%',
      marginTop: 0,
      marginBottom: 0,
      paddingLeft: 16
    }}>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button" onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/home'
            }
          });
        }}>
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="home icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }} />
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Activos' : 'Accounts'}
                      </p>
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/browser'
            }
          });
        }} style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="search icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Buscar' : 'Browse'}
                      </p>
                      
                    </button>
                  </ListItem>

                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/newborrowingacct'
            }
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="newspaper icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Tomar Prestamo' : 'Borrow Funds'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/membertransactions'
            }
          });
        }} style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="wait icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Transacciones' : 'Transactions'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/subscriptionplan'
            }
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="star icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;  
                        {'Blender Pro Plus'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/accountmanagement'
            }
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="star icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;  
                        {'Profile'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          var win = window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank');
          win.focus();
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="book icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Condiciones' : 'Terms of Use'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          var win = window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank');
          win.focus();
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="book icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Privacidad' : 'Privacy Policy'}
                      </p>
                      
                    </button>
                  </ListItem>
                </List><div className="tbp-mobile-menu-actions" style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      borderTop: "1px solid rgba(128,128,128,.25)",
      marginTop: 24,
      paddingTop: 12
    }}><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        width: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%'
      }} onClick={() => {
        trackPageRequest(Auth.signOut());
        that.setState({
          navigationDestinationObject: {
            navigationRoute: '/welcome'
          }
        });
      }}> 
                  <p style={{
          textAlign: 'left',
          fontSize: 16,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          margin: 0,
          width: '100%'
        }}>
                    <i className="sign out icon" style={{
            position: 'static',
            fontSize: 20,
            height: 20,
            lineHeight: 1,
            flexShrink: 0,
            flex: '0 0 22px',
            width: 22,
            margin: 0
          }} />
                    {that.state.selectedLanguage == 'spanish' ? 'Desconectar' : 'Sign Out'}
                  </p>
                </Button><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        width: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%'
      }} onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}>
                  <i style={{
          zIndex: 999,
          textAlign: 'left',
          textAlignVertical: 'top',
          // marginBottom: 0, 
          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)'
          // marginLeft: 5,
          ,

          position: 'static',
          fontSize: 20,
          margin: 0,
          width: 20,
          height: 20,
          lineHeight: 1,
          flexShrink: 0
        }} className={that.state.mode_light_dark == 'dark' ? "sun icon" : "moon icon"} />
                </Button></div></div>
            </Modal>    


            <div className="tbp-mobile-borrow-shell" style={{
              // backgroundColor: 'blue',
              // borderRadius: 10, 
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
              minWidth: 0,
              height: '100dvh',
              display: 'flex',
              overflow: 'hidden',
              margin: 0,
              flexDirection: 'column',
              // borderStyle: 'none',
              borderWidth: 0,    
              position: 'relative',
              left: 0,
              top: 0,
              backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              // border: 'none',   
              // borderColor: 'rgba(177, 177, 177, 0)',
            }}>
            
                <PlatformHeader
                  title={that.state.selectedLanguage === 'spanish' ? 'Línea de crédito' : 'Credit Line'}
                  language={that.state.selectedLanguage}
                  onHome={() => that.setState({ navigationDestinationObject: { navigationRoute: '/home' } })}
                  onMenu={() => that.setState({ navigationOverlay: true })}
                />

                {!that.state.moneyTransferOverlay && <React.Fragment>
                {String(that.state.currentUser).toLowerCase() !== String(that.state.managerUsername).toLowerCase() && (
                  <Button
                    style={{
                      width: 50,
                      height: 50,
                      right: '3vw',
                      bottom: '20vh',
                      position: 'fixed',
                      padding: 1,
                      borderRadius: 38, 
                      zIndex: 99999,
                      borderWidth: 1,
                      backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                      borderColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.3)' : 'rgba(177, 177, 177, 1)',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    onClick={() => {
                      that.addWishlist()
                    }}
                  >
                    <i 
                      className={!that.state.inWishlistBool ? 'bookmark outline icon' : 'bookmark icon'}
                      size={35} 
                      style={{ 
                        position: 'absolute', 
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                        fontSize: 28,
                        top: 18.5, 
                        left: 15,
                        // fontWeight: '400'
                      }}
                    />
                  </Button>
                )}

                <Button
                  style={{
                    width: 50,
                    height: 50,
                    right: '3vw',
                    bottom: '10vh',
                    position: 'fixed',
                    padding: 1,
                    borderRadius: 38, 
                    zIndex: 99999,
                    borderWidth: 1,
                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                    borderColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.3)' : 'rgba(177, 177, 177, 1)',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    that.setState({
                      moneyTransferOverlay: true
                    })
                  }}
                >
                  <i 
                    className={"exchange icon"}
                    size={35} 
                    style={{ 
                      position: 'absolute', 
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                      fontSize: 28,
                      top: 18, 
                      left: 14,
                      // fontWeight: '400'
                    }}
                  />
                </Button>
                </React.Fragment>}




                <div className="tbp-mobile-borrow-content" style={{
                  justifyContent: 'center',
                  alignItems: 'stretch',
                  width: '100%',
                  minWidth: 0,
                  flex: '1 1 0%',
                  minHeight: 0,
                  height: 'auto',
                  overflow: 'hidden',
                  margin: 0,
                  borderStyle: 'none',
                  borderWidth: 0,
                }}>
                  <div
                    className="scrollNoScrollBar tbp-mobile-borrow-scroll"
                    style={{
                      // borderRadius: 10,
                      // backgroundColor: 'red',
                      justifyContent: 'start',
                      alignItems: 'center',
                      width: '100%',
                      maxWidth: '100%',
                      minWidth: 0,
                      boxSizing: 'border-box',
                      position: 'relative',
                      left: 'auto',
                      top: 'auto',
                      bottom: 'auto',
                      height: '100%',
                      minHeight: 0,
                      marginTop: 0,
                      marginBottom: 0,
                      marginRight: 0,
                      marginLeft: '0vw',
                      borderStyle: 'none',
                      borderWidth: 0,
                      scrollbarWidth: 'none',
                      overflowY: 'auto',
                      overflowX: 'hidden'
                    }}
                  >



                      <div className="tbp-borrow-v56-profile"
                        style={{
                          width: '100%',
                          height: 'auto',
                          flexDirection: 'row',
                          display: 'flex',
                          paddingLeft: '3vw',
                          paddingTop: '2vh',
                          paddingBottom: '0px',
                          paddingRight: '3vw',
                          borderRadius: 3,
                          borderColor: 'rgba(177, 177, 177, 1)',
                          justifyContent: 'space-between',
                          alignItems: 'start',
                          marginBottom: '1vh',
                          // backgroundColor: 'red'

                        }}
                      >
                        <p
                          style={{
                            fontSize: 25, 
                            textAlign: 'left',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                          }}
                        >


                          
                          {String(that.state.managerDisplayName).toLowerCase() != String(that.state.managerUsername).toLowerCase() ? String(that.state.managerDisplayName).toUpperCase() : String(that.state.managerUsername).toUpperCase()}
                          {
                            that.state.managerFullName
                            ?
                            <span style = {{  
                              fontSize: 19, 
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              textAlign: 'left',
                              display: 'block',
                            }}>
                              {String(that.state.managerDisplayName).toLowerCase() != String(that.state.managerUsername).toLowerCase() ? String(that.state.managerUsername).toUpperCase() : String(that.state.managerFullName)}
                              &nbsp; &nbsp; 
                              {String(that.state.managerDisplayName).toLowerCase() != String(that.state.managerUsername).toLowerCase() ? '(' : null} 
                              {String(that.state.managerDisplayName).toLowerCase() != String(that.state.managerUsername).toLowerCase() ? String(that.state.managerFullName) : null} 
                              {String(that.state.managerDisplayName).toLowerCase() != String(that.state.managerUsername).toLowerCase() ? ')' : null} 
                            </span>
                            : 
                            null
                          }

                        </p>

                        <Button
                          style={{
                            width: 64,
                            height: 64,
                            right: 0,
                            top: 0,
                            // position: 'absolute',
                            padding: 1,
                            borderRadius: 38, 
                            zIndex: 99999,
                            borderWidth: 1,
                            backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                            borderColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.3)' : 'rgba(177, 177, 177, 1)',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                          onClick={() => {
                            that.setState({
                              socialOverlay: true
                            })
                          }}
                        >
                          <img 
                            className="header_profileImage" 
                            style={{
                              width: 64,
                              height: 64,
                              borderRadius: 32, 
                              borderWidth: 2,
                              borderColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.3)' : 'rgba(177, 177, 177, 1)',
                              justifyContent: 'center',
                              alignItems: 'center',
                              top: 0, 
                              bottom: 0,
                              left: 0, 
                              right: 0, 
                              // marginTop: 0,
                              // width: WIDTH,
                              // justifyContent: 'center',
                              // position: 'position',
                              // top: 0,
                              // zIndex: 999,  
                            }}
                            src={that.state.socialOverlayData_imageURI}
                          />
                          
                        </Button>
                      </div>

                      
                      <div style={{
  width: '100%',
  height: 'auto',
  flexDirection: 'row',
  display: 'flex',
  paddingLeft: '3vw',
  paddingBottom: '3vw',
  paddingTop: '3vw',
  borderRadius: 3,
  borderColor: 'rgba(177, 177, 177, 1)',
  justifyContent: 'space-between'
  // backgroundColor: 'red',
}} className="tbp-credit-stats">
                        
                        <div style={{
    width: '31vw',
    fontSize: 15,
    textAlign: 'left',
    fontWeight: '600',
    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)'
  }} className="tbp-credit-stat">
                          <div style={{
      width: '25vw',
      fontSize: 14,
      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
      textAlign: 'left',
      fontWeight: '500'
    }} className="tbp-credit-stat-label">
                            {that.state.selectedLanguage == 'spanish' ? "Límite de\nCrédito:" : "Credit\nLimit:"}
                          </div>
                          {formatCreditCardUSD(realCreditLimit)}
                        </div>
                        <div style={{
    width: '31vw',
    marginLeft: '3vw',
    fontSize: 15,
    textAlign: 'left',
    fontWeight: '600',
    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)'
  }} className="tbp-credit-stat">
    <div style={{
      width: '25vw',
      fontSize: 14,
      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
      textAlign: 'left',
      fontWeight: '500'
    }} className="tbp-credit-stat-label">
      {that.state.selectedLanguage == 'spanish' ? "Crédito\nDisponible:" : "Available\nCredit:"}
    </div>
    {formatCreditCardUSD(liquidAvailableCredit)}
  
  </div>
  <div style={{
    width: '31vw',
    marginLeft: '3vw',
    fontSize: 15,
    textAlign: 'left',
    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
    fontWeight: '600'
  }} className="tbp-credit-stat">
                          <div style={{
      width: '25vw',
      fontSize: 14,
      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
      textAlign: 'left',
      fontWeight: '500'
    }} className="tbp-credit-stat-label">
                            {that.state.selectedLanguage == 'spanish' ? "Tasa de\nInt. Anual:" : "Annual\nInterest Rate:"}
                          </div>
                          {Number(that.state._intRate).toFixed(0) + ' %'}
                        </div>
                      </div>










                                          
                      <div className="tbp-borrow-v56-chart" 
                        style={{ 
                          zIndex: 2, 
                          position: 'relative', 
                          marginTop: '6vh', 
                          height: '44vh',
                          width: '100vw', 
                          paddingLeft: '0vw', 
                          paddingRight: '0vw', 
                          zIndex: 999999, 
                          paddingTop: '1vh' 
                        }}
                      >
                        <div
                          style={{
                            top: -7,
                            height: '5vh',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            paddingRight: '9vw',
                            width: '100vw',
                            display: 'flex',
                            flexDirection: 'row',
                            paddingLeft: '3vw', 
                            paddingRight: '3vw', 
                          }}
                        >
                          <p style = {{  
                            color: 'rgba(0, 158, 129, 1)',
                            fontSize: 16,
                            // fontWeight: '400',
                            textAlign: 'left',
                            textAlignVertical: 'center',
                            // left: 20,
                            // top: -7,
                            // position: 'absolute',
                            textShadowColor: 'rgba(0, 0, 0, 0.1)',
                            textShadowOffset: {width: -1, height: 1},
                            textShadowRadius: 10, 
                          }}>
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Suma de Contribuciones (USD)  '
                                :
                              'Lender Pool Sum (USD)  '
                            }
                          </p>
                          <Button
                            style={{
                              // right: '3vw',
                              // top: -7,
                              // position: 'absolute',
                              fontWeight: '500',
                              justifyContent: 'center',
                              alignItems: 'center',
                              backgroundColor: 'rgba(0, 0, 0, 0.05)',
                              borderRadius: 3, 
                              height: 35,
                              marginBottom: 15,
                              paddingTop: 0,
                              paddingBottom: 0,
                              paddingLeft: 15,
                              paddingRight: 15,

                            }}
                            onClick={() => {
                              that.changeChartDayRange()
                            }}
                            disabled={that.state.disableChangeChartDayRange}
                          >
                            <p style = {{  
                              color: 'rgba(0, 158, 129, 1)',
                              fontSize: 11,
                              fontWeight: '500',
                              textAlign: 'center',
                              // marginTop: 1, 
                              position: 'relative',
                              top: 0, 
                              bottom: 0,
                              textAlignVertical: 'center',
                              textShadowColor: 'rgba(0, 0, 0, 0.1)',
                              textShadowOffset: {width: -1, height: 1},
                              textShadowRadius: 10, 
                            }}>
                              {that.state.timePeriodString}
                            </p>
                          </Button>
                        </div>


                        {
                          that.state._values.length >= 30
                          ?
                          <ResponsiveContainer 
                            width="100%" 
                            height="90%" 
                            style={{
                              borderColor: 'rgba(0, 0, 0, 0)',
                              // borderColor: 'rgba(0, 158, 129, 1)',
                              borderStyle: 'solid',
                              borderWidth: 1,
                              marginBottom: '2vw',
                              marginRight: '0vw',
                              position: 'relative',
                            }}
                          >
                            <LineChart 
                              width="100%" 
                              height="100%" 
                              data={that.state._values} 
                              margin={{ 
                                top: 5, 
                                right: 5, 
                                left: 0,
                                bottom: 5 
                              }}
                              style={{
                                left: '-4vw',
                              }}
                            >
                              {/* <Legend /> */}
                              <XAxis 
                                dataKey="name"
                                // hide={true}
                                tickCount={3}
                                minTickGap={25}
                                tick={(payload) => {

                                  if (payload) {
                                    return (
                                      <g transform={`translate(${payload.x},${payload.y})`}>
                                        <text 
                                          x={50} 
                                          y={0} 
                                          dy={16}
                                          textAnchor="end" 
                                          fill="#666" 
                                          // transform="rotate(-35)"
                                          style={{
                                            fontSize: 10,
                                            textAlign: 'left',
                                          }}
                                        >
                                          {String(payload.payload.value)}
                                        </text>
                                      </g>
                                    )
                                  } 

                                }}
                                interval={Math.floor(that.state._values.length/4)}
                                // interval={'preserveEnd'}

                              />
                              <YAxis 
                                // stroke={'#282c34'}
                                tickCount={3}
                              />
                              <Tooltip 
                                active={true}
                                cursor={true}
                                content={({ active, payload, label }) => {
                                  if (active && payload && payload.length) {
                                    return (
                                      <div
                                        style={{
                                          backgroundColor: that.state.mode_light_dark === 'light' ? '#ffffff' : '#14253b',
                                          height: 'auto',
                                          minWidth: 120,
                                          color: that.state.mode_light_dark === 'light' ? '#182b42' : '#eef6ff',
                                          border: 'none',
                                          borderRadius: 10,
                                          display: 'flex',
                                          flexDirection: 'row',
                                          // overflowX: 'hidden',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <div
                                          style={{
                                            backgroundColor: that.state.mode_light_dark === 'light' ? '#ffffff' : '#14253b',
                                            height: 'auto',
                                            minWidth: 120,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            // overflowX: 'hidden',
                                            justifyContent: 'start',
                                            alignItems: 'start',
                                            padding: 12,
                                          }}
                                        >
                                          <p 
                                            style={{
                                              fontSize: 14,
                                              marginBottom: 0,
                                              textAlign: 'left',
                                            }}
                                          >
                                            {`${label}`}
                                          </p>
                                          <p 
                                            style={{
                                              fontSize: 14,
                                              marginTop: 0,
                                              textAlign: 'left',
                                            }}
                                          >
                                            {`${Number(payload[0].value).toFixed(2)} USD`}
                                          </p>
                                        </div>
                                      </div>
                                    )
                                  } 

                                  return null
                                    // <div
                                    //   style={{
                                    //     backgroundColor: 'rgba(255, 255, 255, 1)',
                                    //     height: '7vh',
                                    //     width: '7vw',
                                    //   }}
                                    // />
                                }}
                              />
                              {/* <CartesianGrid strokeDasharray="3 3" /> */}
                              <Line 
                                activeDot={{ r: 4 }}
                                dot={false}
                                type="monotone" 
                                dataKey="availableCredit" 
                                stroke="#009e81" 
                                onMouseMove={() => {
                                }}
                              />
                            </LineChart>
                          </ResponsiveContainer>
                          :
                          null
                        }

                      </div>


        






                        <div className="tbp-borrow-v56-details" 
                          style={{
  zIndex: 99999,
  position: 'relative',
  marginTop: '2vh',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'top',
  width: '100vw',
  height: "auto",
  marginRight: '3vw',
  paddingRight: '3vw',
  paddingTop: '4vh'
  // backgroundColor: 'blue'
  ,
  paddingBottom: 32
}}  
                        >
  



                          <div className="tbp-borrow-v56-stats-panel" style={{ zIndex: 2, position: 'relative', top: 0, width: '63vw', paddingRight: '4vw', paddingLeft: '3vw', paddingTop: '0vh', }} >
                            <div className="tbp-borrow-v56-stats-heading">
                              <h2>{that.state.selectedLanguage === 'spanish' ? 'Estadísticas de Cuenta' : 'Account Stats'}</h2>
                            </div>
                            <div className="tbp-borrow-v56-stats-list"
                              style={{
                                width: '63vw',
                                height: 'auto',
                                paddingLeft: '0vw',
                                paddingRight: '5vw',
                                paddingTop: '0vh',
                                borderRadius: 3,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginBottom: '0vh',
                              }}
                            >
                              <React.Fragment>
                                  {that.state.accountStatsArray.map(listItem => (
                                  
                                        
                                      <Button className="tbp-borrow-v56-stat-item" 
                                        onClick={() => {
                                          that.setState({
                                            statDesc: listItem.statDesc,
                                            statName: listItem.statName,
                                            statValue: listItem.statValue,
                                            statColor: listItem.statColor,
                                            statExplanationOverlay: true,
                                          })
                                        }}
                                        disabled={listItem.disabled}
                                        style={{
                                          borderWidth: 0,
                                          display: 'flex',
                                          paddingLeft: 0,
                                          width: '63vw',
                                          height: '60px',
                                          paddingRight: '4vw',
                                          flexDirection: "column",
                                          justifyContent: 'space-between',
                                          alignItems: 'start',
                                          backgroundColor: 'rgba(255, 255, 255, 0)',
                                          marginBottom: 0,
                                        }}
                                      >

                                            
                                            <p style={{ 
                                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',  
                                                fontSize: 15,
                                                                                                lineHeight: '20px',
                                                marginTop: 0,
                                                marginBottom: 0,
                                                paddingTop: 0,
                                                paddingBottom: 0,
justifyContent: 'center',
                                                textAlign: 'left', 
                                                position: 'relative',
                                                textAlignVertical: 'center',
                                                bottom: 0,
                                                fontWeight: '500',
                                                marginBottom: 0,
                                            }}> 
                                                {listItem.statName}
                                            </p>
                                            <p style={{  
                                                marginTop: 0,
                                                color: 'rgba(0, 158, 129, 1)',
                                                fontSize: 15,
                                                                                                lineHeight: '20px',
                                                marginTop: 0,
                                                marginBottom: 0,
                                                paddingTop: 0,
                                                paddingBottom: 0,
justifyContent: 'center',
                                                position: 'relative',
                                                textAlign: 'right', 
                                                textAlignVertical: 'center',
                                                bottom: 0,
                                                fontWeight: '500',
                                            }}> 
                                                {listItem.statValue}{' '}
                                                {
                                                // listItem.statName == 'Blender Score' ?
                                                    // <Icon1 name={'ios-ribbon'} size={14} style={{
                                                    //     position: 'absolute',
                                                    //     bottom: 0,
                                                    //     right: 27,
                                                    //     marginBottom: 40,  
                                                    //     color: 'rgba(0, 158, 129, 1)',
                                                    //     paddingBottom: 15,
                                                    // }}/> :
                                                    // null
                                                }
                                            </p>
                                    
                                      </Button>


                                  ))}
                              </React.Fragment>
                            </div>
                          </div>




                        </div>


 
                        

                        <PlatformFooter language={that.state.selectedLanguage} mobile className="tbp-borrow-v56-footer" />


                  </div>
                  
                </div>

              </div>

          </div>
        )
    );
  }
}

export default BorrowingAccountMobileRender;
